var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 392,
    viewBox: "0 0 498 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 496,
    height: 390,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 55,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 103,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 151,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_ii_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 199,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_ii_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 247,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_ii_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 295,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_ii_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 343,
    width: 90,
    height: 48,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 47,
    y: 87,
    width: 86,
    height: 54,
    rx: 4,
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 137.948L56 136.86L53.664 136.86L53.664 134.908L52.576 134.908L52.576 136.86L51.328 136.86L51.328 134.428L50.24 134.428L50.24 137.948L56 137.948ZM56.12 131.234C56.12 129.506 54.912 128.442 53.12 128.442C51.328 128.442 50.12 129.506 50.12 131.234C50.12 132.962 51.328 134.026 53.12 134.026C54.912 134.026 56.12 132.962 56.12 131.234ZM53.12 132.874C51.92 132.874 51.128 132.33 51.144 131.234C51.16 130.138 51.92 129.594 53.12 129.594C54.32 129.594 55.112 130.138 55.096 131.234C55.08 132.33 54.32 132.874 53.12 132.874ZM56.12 125.171C56.12 123.851 55.416 122.923 54.296 122.555L53.992 123.651C54.688 123.867 55.096 124.371 55.096 125.171C55.096 126.267 54.32 126.819 53.12 126.819C51.92 126.819 51.144 126.267 51.144 125.171C51.144 124.371 51.552 123.867 52.248 123.651L51.944 122.555C50.824 122.923 50.12 123.851 50.12 125.171C50.12 126.899 51.328 127.963 53.12 127.963C54.912 127.963 56.12 126.899 56.12 125.171ZM56.12 119.33C56.12 117.938 55.224 116.986 53.84 116.986L50.24 116.986L50.24 118.09L53.832 118.09C54.576 118.09 55.096 118.626 55.096 119.33C55.096 120.018 54.592 120.57 53.832 120.57L50.24 120.57L50.248 121.674L53.84 121.674C55.224 121.674 56.12 120.722 56.12 119.33ZM56.12 113.936C56.12 112.76 55.528 111.624 54.288 111.624C53.128 111.624 52.84 112.624 52.68 113.216L52.408 114.216C52.312 114.584 52.168 114.984 51.792 114.984C51.384 114.984 51.128 114.504 51.144 113.992C51.16 113.472 51.456 112.976 52.016 112.848L51.816 111.672C50.736 111.952 50.144 112.784 50.128 113.976C50.12 115.16 50.688 116.128 51.848 116.128C52.944 116.128 53.224 115.272 53.352 114.824L53.792 113.328C53.928 112.88 54.136 112.768 54.368 112.768C54.848 112.768 55.104 113.328 55.104 113.864C55.104 114.504 54.736 115.056 54.072 115.216L54.24 116.352C55.408 116.176 56.12 115.216 56.12 113.936ZM56 109.143L56 108.055L54.048 108.055L54.048 106.711C54.048 106.607 54.04 106.383 54.016 106.231C53.856 105.207 53.112 104.743 52.144 104.743C51.176 104.743 50.432 105.199 50.272 106.231C50.248 106.383 50.24 106.599 50.24 106.711L50.24 109.143L56 109.143ZM53.032 108.055L51.256 108.055L51.256 106.759C51.256 106.647 51.264 106.503 51.296 106.391C51.416 105.951 51.832 105.839 52.144 105.839C52.456 105.839 52.872 105.951 52.992 106.391C53.024 106.503 53.032 106.647 53.032 106.759L53.032 108.055ZM56 103.94L56 100.18L54.984 100.18L54.984 102.852L53.504 102.852L53.504 100.66L52.488 100.66L52.488 102.852L51.256 102.852L51.256 100.18L50.24 100.18L50.24 103.94L56 103.94ZM56 99.6212L56 98.5012L54.8 98.1372L54.8 95.9692L56 95.5972L56 94.4772L50.24 96.2372L50.24 97.8612L56 99.6212ZM53.784 97.8292L51.26 97.0612L53.784 96.2812L53.784 97.8292ZM56 93.7603L56 92.6723L53.376 92.6723L56 90.3763L56 89.0003L53.08 91.5603L50.24 89.1523L50.24 90.4803L52.896 92.6723L50.24 92.6723L50.24 93.7603L56 93.7603Z",
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 47,
    y: 265,
    width: 86,
    height: 54,
    rx: 4,
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3125 305.359L56 305.359L56 306.531L50.3125 306.531L50.3125 305.359ZM52.7422 303.094L53.6562 303.094L53.6562 305.68L52.7422 305.68L52.7422 303.094ZM50.3125 302.82L51.2305 302.82L51.2305 305.68L50.3125 305.68L50.3125 302.82ZM53.0234 297.469L53.293 297.469C53.7253 297.469 54.1133 297.527 54.457 297.645C54.8008 297.762 55.0937 297.927 55.3359 298.141C55.5755 298.354 55.7591 298.609 55.8867 298.906C56.0143 299.201 56.0781 299.527 56.0781 299.887C56.0781 300.243 56.0143 300.57 55.8867 300.867C55.7591 301.161 55.5755 301.417 55.3359 301.633C55.0937 301.849 54.8008 302.017 54.457 302.137C54.1133 302.254 53.7253 302.312 53.293 302.312L53.0234 302.312C52.5885 302.312 52.2005 302.254 51.8594 302.137C51.5156 302.02 51.2227 301.854 50.9805 301.641C50.7383 301.424 50.5534 301.169 50.4258 300.875C50.2982 300.578 50.2344 300.251 50.2344 299.895C50.2344 299.535 50.2982 299.208 50.4258 298.914C50.5534 298.617 50.7383 298.362 50.9805 298.148C51.2227 297.932 51.5156 297.766 51.8594 297.648C52.2005 297.529 52.5885 297.469 53.0234 297.469ZM53.293 298.652L53.0156 298.652C52.7135 298.652 52.4479 298.68 52.2187 298.734C51.9896 298.789 51.7969 298.87 51.6406 298.977C51.4844 299.083 51.3672 299.214 51.2891 299.367C51.2083 299.521 51.168 299.697 51.168 299.895C51.168 300.092 51.2083 300.268 51.2891 300.422C51.3672 300.573 51.4844 300.702 51.6406 300.809C51.7969 300.913 51.9896 300.992 52.2187 301.047C52.4479 301.102 52.7135 301.129 53.0156 301.129L53.293 301.129C53.5924 301.129 53.8581 301.102 54.0898 301.047C54.319 300.992 54.513 300.911 54.6719 300.805C54.8281 300.698 54.9466 300.568 55.0273 300.414C55.1081 300.26 55.1484 300.085 55.1484 299.887C55.1484 299.689 55.1081 299.513 55.0273 299.359C54.9466 299.206 54.8281 299.077 54.6719 298.973C54.513 298.868 54.319 298.789 54.0898 298.734C53.8581 298.68 53.5924 298.652 53.293 298.652ZM54.1133 293.328L54.1133 292.16C54.4961 292.184 54.8359 292.289 55.1328 292.477C55.4297 292.661 55.6615 292.921 55.8281 293.254C55.9948 293.585 56.0781 293.983 56.0781 294.449C56.0781 294.814 56.0156 295.141 55.8906 295.43C55.763 295.719 55.5807 295.966 55.3437 296.172C55.1068 296.375 54.8203 296.53 54.4844 296.637C54.1484 296.743 53.7721 296.797 53.3555 296.797L52.9609 296.797C52.5443 296.797 52.168 296.742 51.832 296.633C51.4935 296.521 51.2057 296.362 50.9687 296.156C50.7318 295.948 50.5495 295.699 50.4219 295.41C50.2943 295.121 50.2305 294.798 50.2305 294.441C50.2305 293.967 50.3164 293.568 50.4883 293.242C50.6602 292.914 50.8971 292.66 51.1992 292.48C51.5013 292.298 51.8451 292.189 52.2305 292.152L52.2305 293.324C52.0013 293.337 51.8073 293.383 51.6484 293.461C51.487 293.539 51.3659 293.658 51.2852 293.816C51.2018 293.973 51.1602 294.181 51.1602 294.441C51.1602 294.637 51.1966 294.807 51.2695 294.953C51.3424 295.099 51.4531 295.221 51.6016 295.32C51.75 295.419 51.9375 295.493 52.1641 295.543C52.388 295.59 52.651 295.613 52.9531 295.613L53.3555 295.613C53.6497 295.613 53.9089 295.591 54.1328 295.547C54.3542 295.503 54.5417 295.435 54.6953 295.344C54.8464 295.25 54.9609 295.13 55.0391 294.984C55.1146 294.836 55.1523 294.658 55.1523 294.449C55.1523 294.204 55.1133 294.003 55.0352 293.844C54.957 293.685 54.8411 293.564 54.6875 293.48C54.5339 293.395 54.3424 293.344 54.1133 293.328ZM50.3125 288.25L50.3125 287.082L54.0703 287.082C54.5078 287.082 54.8763 287.176 55.1758 287.363C55.4753 287.548 55.7005 287.805 55.8516 288.133C56.0026 288.458 56.0781 288.833 56.0781 289.258C56.0781 289.682 56.0026 290.06 55.8516 290.391C55.7005 290.719 55.4753 290.977 55.1758 291.164C54.8763 291.349 54.5078 291.441 54.0703 291.441L50.3125 291.441L50.3125 290.27L54.0703 290.27C54.3255 290.27 54.5339 290.229 54.6953 290.148C54.8568 290.068 54.9753 289.952 55.0508 289.801C55.1263 289.647 55.1641 289.466 55.1641 289.258C55.1641 289.044 55.1263 288.863 55.0508 288.715C54.9753 288.564 54.8568 288.449 54.6953 288.371C54.5339 288.29 54.3255 288.25 54.0703 288.25L50.3125 288.25ZM54.5117 283.156C54.4102 283.156 54.319 283.172 54.2383 283.203C54.1549 283.232 54.0794 283.286 54.0117 283.367C53.9414 283.448 53.8724 283.561 53.8047 283.707C53.737 283.853 53.6667 284.042 53.5937 284.273C53.5104 284.531 53.4167 284.776 53.3125 285.008C53.2083 285.237 53.0872 285.44 52.9492 285.617C52.8086 285.792 52.6458 285.93 52.4609 286.031C52.276 286.13 52.0612 286.18 51.8164 286.18C51.5794 286.18 51.3646 286.128 51.1719 286.023C50.9766 285.919 50.8099 285.773 50.6719 285.586C50.5312 285.398 50.4232 285.177 50.3477 284.922C50.2721 284.664 50.2344 284.382 50.2344 284.074C50.2344 283.655 50.3099 283.289 50.4609 282.977C50.612 282.664 50.819 282.422 51.082 282.25C51.3451 282.076 51.6458 281.988 51.9844 281.988L51.9844 283.152C51.8177 283.152 51.6719 283.187 51.5469 283.258C51.4193 283.326 51.319 283.43 51.2461 283.57C51.1732 283.708 51.1367 283.883 51.1367 284.094C51.1367 284.297 51.168 284.466 51.2305 284.602C51.2904 284.737 51.3724 284.839 51.4766 284.906C51.5781 284.974 51.6927 285.008 51.8203 285.008C51.9167 285.008 52.0039 284.984 52.082 284.937C52.1602 284.888 52.2331 284.815 52.3008 284.719C52.3685 284.622 52.4323 284.504 52.4922 284.363C52.5521 284.223 52.6107 284.06 52.668 283.875C52.7617 283.565 52.8672 283.293 52.9844 283.059C53.1016 282.822 53.2331 282.624 53.3789 282.465C53.5247 282.306 53.6901 282.186 53.875 282.105C54.0599 282.025 54.2695 281.984 54.5039 281.984C54.7513 281.984 54.9727 282.033 55.168 282.129C55.3633 282.225 55.5286 282.365 55.6641 282.547C55.7995 282.729 55.9023 282.947 55.9727 283.199C56.043 283.452 56.0781 283.734 56.0781 284.047C56.0781 284.328 56.0417 284.605 55.9687 284.879C55.8932 285.152 55.7799 285.401 55.6289 285.625C55.4779 285.846 55.2852 286.023 55.0508 286.156C54.8164 286.289 54.5391 286.355 54.2187 286.355L54.2187 285.18C54.3958 285.18 54.5456 285.152 54.668 285.098C54.7904 285.043 54.8893 284.966 54.9648 284.867C55.0404 284.766 55.0951 284.646 55.1289 284.508C55.1628 284.367 55.1797 284.214 55.1797 284.047C55.1797 283.844 55.151 283.677 55.0937 283.547C55.0365 283.414 54.957 283.316 54.8555 283.254C54.7539 283.189 54.6393 283.156 54.5117 283.156ZM56 277.449L56 278.687L55.0859 278.68L55.0859 277.449C55.0859 277.142 55.0169 276.883 54.8789 276.672C54.7383 276.461 54.5339 276.302 54.2656 276.195C53.9974 276.086 53.6732 276.031 53.293 276.031L53.0156 276.031C52.724 276.031 52.4674 276.062 52.2461 276.125C52.0247 276.185 51.8385 276.275 51.6875 276.395C51.5365 276.514 51.4232 276.661 51.3477 276.836C51.2695 277.01 51.2305 277.211 51.2305 277.437L51.2305 278.711L50.3125 278.711L50.3125 277.437C50.3125 277.057 50.3776 276.71 50.5078 276.395C50.6354 276.077 50.819 275.802 51.0586 275.57C51.2982 275.339 51.5846 275.16 51.918 275.035C52.2487 274.908 52.6172 274.844 53.0234 274.844L53.293 274.844C53.6966 274.844 54.0651 274.908 54.3984 275.035C54.7318 275.16 55.0182 275.339 55.2578 275.57C55.4948 275.799 55.6784 276.074 55.8086 276.395C55.9362 276.712 56 277.064 56 277.449ZM50.3125 278.023L56 278.023L56 279.195L50.3125 279.195L50.3125 278.023ZM50.3125 272.746L56 272.746L56 273.914L50.3125 273.914L50.3125 272.746ZM53.9727 269.434L53.9727 270.883L53.0586 270.883L53.0586 269.434C53.0586 269.21 53.0221 269.027 52.9492 268.887C52.8737 268.746 52.7695 268.643 52.6367 268.578C52.5039 268.513 52.3542 268.48 52.1875 268.48C52.0182 268.48 51.8607 268.513 51.7148 268.578C51.569 268.643 51.4518 268.746 51.3633 268.887C51.2747 269.027 51.2305 269.21 51.2305 269.434L51.2305 270.477L56 270.477L56 271.648L50.3125 271.648L50.3125 269.434C50.3125 268.988 50.3932 268.607 50.5547 268.289C50.7135 267.969 50.9336 267.724 51.2148 267.555C51.4961 267.385 51.8177 267.301 52.1797 267.301C52.5469 267.301 52.8646 267.385 53.1328 267.555C53.401 267.724 53.6081 267.969 53.7539 268.289C53.8997 268.607 53.9727 268.988 53.9727 269.434Z",
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 136,
    y: 79,
    width: 87,
    height: 54,
    rx: 4,
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 129.948L145 128.86L142.664 128.86L142.664 126.908L141.576 126.908L141.576 128.86L140.328 128.86L140.328 126.428L139.24 126.428L139.24 129.948L145 129.948ZM145.12 123.234C145.12 121.506 143.912 120.442 142.12 120.442C140.328 120.442 139.12 121.506 139.12 123.234C139.12 124.962 140.328 126.026 142.12 126.026C143.912 126.026 145.12 124.962 145.12 123.234ZM142.12 124.874C140.92 124.874 140.128 124.33 140.144 123.234C140.16 122.138 140.92 121.594 142.12 121.594C143.32 121.594 144.112 122.138 144.096 123.234C144.08 124.33 143.32 124.874 142.12 124.874ZM145.12 117.171C145.12 115.851 144.416 114.923 143.296 114.555L142.992 115.651C143.688 115.867 144.096 116.371 144.096 117.171C144.096 118.267 143.32 118.819 142.12 118.819C140.92 118.819 140.144 118.267 140.144 117.171C140.144 116.371 140.552 115.867 141.248 115.651L140.944 114.555C139.824 114.923 139.12 115.851 139.12 117.171C139.12 118.899 140.328 119.963 142.12 119.963C143.912 119.963 145.12 118.899 145.12 117.171ZM145.12 111.33C145.12 109.938 144.224 108.986 142.84 108.986L139.24 108.986L139.24 110.09L142.832 110.09C143.576 110.09 144.096 110.626 144.096 111.33C144.096 112.018 143.592 112.57 142.832 112.57L139.24 112.57L139.248 113.674L142.84 113.674C144.224 113.674 145.12 112.722 145.12 111.33ZM145.12 105.936C145.12 104.76 144.528 103.624 143.288 103.624C142.128 103.624 141.84 104.624 141.68 105.216L141.408 106.216C141.312 106.584 141.168 106.984 140.792 106.984C140.384 106.984 140.128 106.504 140.144 105.992C140.16 105.472 140.456 104.976 141.016 104.848L140.816 103.672C139.736 103.952 139.144 104.784 139.128 105.976C139.12 107.16 139.688 108.128 140.848 108.128C141.944 108.128 142.224 107.272 142.352 106.824L142.792 105.328C142.928 104.88 143.136 104.768 143.368 104.768C143.848 104.768 144.104 105.328 144.104 105.864C144.104 106.504 143.736 107.056 143.072 107.216L143.24 108.352C144.408 108.176 145.12 107.216 145.12 105.936ZM145 101.143L145 100.055L143.048 100.055L143.048 98.7111C143.048 98.6071 143.04 98.3831 143.016 98.2311C142.856 97.2071 142.112 96.7431 141.144 96.7431C140.176 96.7431 139.432 97.1991 139.272 98.2311C139.248 98.3831 139.24 98.5991 139.24 98.7111L139.24 101.143L145 101.143ZM142.032 100.055L140.256 100.055L140.256 98.7591C140.256 98.6471 140.264 98.5031 140.296 98.3911C140.416 97.9511 140.832 97.8391 141.144 97.8391C141.456 97.8391 141.872 97.9511 141.992 98.3911C142.024 98.5031 142.032 98.6471 142.032 98.7591L142.032 100.055ZM145 95.94L145 92.18L143.984 92.18L143.984 94.852L142.504 94.852L142.504 92.66L141.488 92.66L141.488 94.852L140.256 94.852L140.256 92.18L139.24 92.18L139.24 95.94L145 95.94ZM145 91.6212L145 90.5012L143.8 90.1372L143.8 87.9692L145 87.5972L145 86.4772L139.24 88.2372L139.24 89.8612L145 91.6212ZM142.784 89.8292L140.26 89.0612L142.784 88.2812L142.784 89.8292ZM145 85.7603L145 84.6723L142.376 84.6723L145 82.3763L145 81.0003L142.08 83.5603L139.24 81.1523L139.24 82.4803L141.896 84.6723L139.24 84.6723L139.24 85.7603L145 85.7603Z",
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_i_1780_28321)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 54,
    transform: "translate(47 1)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4648 11.4688H80.7773L83.2441 18.0488L85.7051 11.4688H87.0176L83.7598 20H82.7168L79.4648 11.4688ZM78.8672 11.4688H80.1152L80.332 17.1641V20H78.8672V11.4688ZM86.3672 11.4688H87.6211V20H86.1504V17.1641L86.3672 11.4688ZM96.1699 15.5V15.9688C96.1699 16.6133 96.0859 17.1914 95.918 17.7031C95.75 18.2148 95.5098 18.6504 95.1973 19.0098C94.8887 19.3691 94.5176 19.6445 94.084 19.8359C93.6504 20.0234 93.1699 20.1172 92.6426 20.1172C92.1191 20.1172 91.6406 20.0234 91.207 19.8359C90.7773 19.6445 90.4043 19.3691 90.0879 19.0098C89.7715 18.6504 89.5254 18.2148 89.3496 17.7031C89.1777 17.1914 89.0918 16.6133 89.0918 15.9688V15.5C89.0918 14.8555 89.1777 14.2793 89.3496 13.7715C89.5215 13.2598 89.7637 12.8242 90.0762 12.4648C90.3926 12.1016 90.7656 11.8262 91.1953 11.6387C91.6289 11.4473 92.1074 11.3516 92.6309 11.3516C93.1582 11.3516 93.6387 11.4473 94.0723 11.6387C94.5059 11.8262 94.8789 12.1016 95.1914 12.4648C95.5039 12.8242 95.7441 13.2598 95.9121 13.7715C96.084 14.2793 96.1699 14.8555 96.1699 15.5ZM94.6992 15.9688V15.4883C94.6992 15.0117 94.6523 14.5918 94.5586 14.2285C94.4688 13.8613 94.334 13.5547 94.1543 13.3086C93.9785 13.0586 93.7617 12.8711 93.5039 12.7461C93.2461 12.6172 92.9551 12.5527 92.6309 12.5527C92.3066 12.5527 92.0176 12.6172 91.7637 12.7461C91.5098 12.8711 91.293 13.0586 91.1133 13.3086C90.9375 13.5547 90.8027 13.8613 90.709 14.2285C90.6152 14.5918 90.5684 15.0117 90.5684 15.4883V15.9688C90.5684 16.4453 90.6152 16.8672 90.709 17.2344C90.8027 17.6016 90.9395 17.9121 91.1191 18.166C91.3027 18.416 91.5215 18.6055 91.7754 18.7344C92.0293 18.8594 92.3184 18.9219 92.6426 18.9219C92.9707 18.9219 93.2617 18.8594 93.5156 18.7344C93.7695 18.6055 93.9844 18.416 94.1602 18.166C94.3359 17.9121 94.4688 17.6016 94.5586 17.2344C94.6523 16.8672 94.6992 16.4453 94.6992 15.9688ZM104.408 11.4688V20H102.938L99.1113 13.8887V20H97.6406V11.4688H99.1113L102.949 17.5918V11.4688H104.408Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9062 33.4554V44.8695H87.0234V35.6898L84.2344 36.6351V35.0804L88.6797 33.4554H88.9062ZM100.484 43.3695V44.8695H92.8594V43.5804L96.5625 39.5414C96.9688 39.083 97.2891 38.6872 97.5234 38.3539C97.7578 38.0205 97.9219 37.7211 98.0156 37.4554C98.1146 37.1846 98.1641 36.9216 98.1641 36.6664C98.1641 36.307 98.0964 35.9919 97.9609 35.7211C97.8307 35.445 97.638 35.2289 97.3828 35.0726C97.1276 34.9112 96.8177 34.8304 96.4531 34.8304C96.0312 34.8304 95.6771 34.9216 95.3906 35.1039C95.1042 35.2862 94.888 35.5388 94.7422 35.8617C94.5964 36.1794 94.5234 36.544 94.5234 36.9554H92.6406C92.6406 36.294 92.7917 35.6898 93.0938 35.1429C93.3958 34.5909 93.8333 34.1534 94.4062 33.8304C94.9792 33.5023 95.6693 33.3383 96.4766 33.3383C97.237 33.3383 97.8828 33.4659 98.4141 33.7211C98.9453 33.9763 99.349 34.3383 99.625 34.807C99.9062 35.2758 100.047 35.8304 100.047 36.4711C100.047 36.8252 99.9896 37.1768 99.875 37.5258C99.7604 37.8747 99.5964 38.2237 99.3828 38.5726C99.1745 38.9164 98.9271 39.2627 98.6406 39.6117C98.3542 39.9554 98.0391 40.3044 97.6953 40.6586L95.2344 43.3695H100.484Z",
    fill: "#3D4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.377 11.4688V20H173.918V11.4688H175.377ZM178.055 11.4688V12.6406H171.264V11.4688H178.055ZM183.967 11.4688H185.432V17.1699C185.432 17.8184 185.291 18.3613 185.01 18.7988C184.729 19.2363 184.346 19.5664 183.861 19.7891C183.381 20.0078 182.844 20.1172 182.25 20.1172C181.637 20.1172 181.09 20.0078 180.609 19.7891C180.129 19.5664 179.75 19.2363 179.473 18.7988C179.199 18.3613 179.062 17.8184 179.062 17.1699V11.4688H180.527V17.1699C180.527 17.5801 180.598 17.918 180.738 18.1836C180.879 18.4453 181.078 18.6387 181.336 18.7637C181.594 18.8887 181.898 18.9512 182.25 18.9512C182.602 18.9512 182.904 18.8887 183.158 18.7637C183.416 18.6387 183.615 18.4453 183.756 18.1836C183.896 17.918 183.967 17.5801 183.967 17.1699V11.4688ZM192.615 18.834V20H188.086V18.834H192.615ZM188.502 11.4688V20H187.031V11.4688H188.502ZM192.023 15.0312V16.1797H188.086V15.0312H192.023ZM192.586 11.4688V12.6406H188.086V11.4688H192.586Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.906 33.4554V44.8695H177.023V35.6898L174.234 36.6351V35.0804L178.68 33.4554H178.906ZM185.07 38.3304H186.195C186.633 38.3304 186.995 38.2549 187.281 38.1039C187.573 37.9528 187.789 37.7445 187.93 37.4789C188.07 37.2133 188.141 36.9086 188.141 36.5648C188.141 36.2054 188.076 35.8982 187.945 35.6429C187.82 35.3825 187.628 35.182 187.367 35.0414C187.112 34.9008 186.786 34.8304 186.391 34.8304C186.057 34.8304 185.755 34.8982 185.484 35.0336C185.219 35.1638 185.008 35.3513 184.852 35.5961C184.695 35.8357 184.617 36.1221 184.617 36.4554H182.727C182.727 35.8513 182.885 35.3148 183.203 34.8461C183.521 34.3773 183.953 34.0101 184.5 33.7445C185.052 33.4737 185.672 33.3383 186.359 33.3383C187.094 33.3383 187.734 33.4607 188.281 33.7054C188.833 33.945 189.263 34.3044 189.57 34.7836C189.878 35.2627 190.031 35.8565 190.031 36.5648C190.031 36.8877 189.956 37.2159 189.805 37.5492C189.654 37.8825 189.43 38.1872 189.133 38.4633C188.836 38.7341 188.466 38.9554 188.023 39.1273C187.581 39.294 187.068 39.3773 186.484 39.3773H185.07V38.3304ZM185.07 39.7992V38.7679H186.484C187.151 38.7679 187.719 38.8461 188.188 39.0023C188.661 39.1586 189.047 39.3747 189.344 39.6508C189.641 39.9216 189.857 40.2315 189.992 40.5804C190.133 40.9294 190.203 41.2992 190.203 41.6898C190.203 42.2211 190.107 42.695 189.914 43.1117C189.727 43.5232 189.458 43.8721 189.109 44.1586C188.76 44.445 188.352 44.6612 187.883 44.807C187.419 44.9528 186.914 45.0258 186.367 45.0258C185.878 45.0258 185.409 44.958 184.961 44.8226C184.513 44.6872 184.112 44.4867 183.758 44.2211C183.404 43.9502 183.122 43.6143 182.914 43.2133C182.711 42.807 182.609 42.3383 182.609 41.807H184.492C184.492 42.1455 184.57 42.445 184.727 42.7054C184.888 42.9607 185.112 43.1612 185.398 43.307C185.69 43.4528 186.023 43.5258 186.398 43.5258C186.794 43.5258 187.135 43.4554 187.422 43.3148C187.708 43.1742 187.927 42.9659 188.078 42.6898C188.234 42.4138 188.312 42.0804 188.312 41.6898C188.312 41.2471 188.227 40.8877 188.055 40.6117C187.883 40.3357 187.638 40.1325 187.32 40.0023C187.003 39.8669 186.628 39.7992 186.195 39.7992H185.07Z",
    fill: "#3D4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.006 18.084L263.705 11.4688H264.596L264.496 13.1738L262.68 20H261.754L262.006 18.084ZM260.734 11.4688L262.111 18.0312L262.234 20H261.25L259.275 11.4688H260.734ZM266.523 18.0137L267.883 11.4688H269.348L267.373 20H266.389L266.523 18.0137ZM264.941 11.4688L266.623 18.1016L266.869 20H265.943L264.156 13.1738L264.062 11.4688H264.941ZM276.021 18.834V20H271.492V18.834H276.021ZM271.908 11.4688V20H270.438V11.4688H271.908ZM275.43 15.0312V16.1797H271.492V15.0312H275.43ZM275.992 11.4688V12.6406H271.492V11.4688H275.992ZM279.701 20H277.879L277.891 18.834H279.701C280.229 18.834 280.67 18.7188 281.025 18.4883C281.385 18.2578 281.654 17.9277 281.834 17.498C282.018 17.0684 282.109 16.5566 282.109 15.9629V15.5C282.109 15.0391 282.057 14.6309 281.951 14.2754C281.85 13.9199 281.697 13.6211 281.494 13.3789C281.295 13.1367 281.049 12.9531 280.756 12.8281C280.467 12.7031 280.133 12.6406 279.754 12.6406H277.844V11.4688H279.754C280.32 11.4688 280.838 11.5645 281.307 11.7559C281.775 11.9434 282.18 12.2148 282.52 12.5703C282.863 12.9258 283.127 13.3516 283.311 13.8477C283.494 14.3438 283.586 14.8984 283.586 15.5117V15.9629C283.586 16.5762 283.494 17.1309 283.311 17.627C283.127 18.123 282.863 18.5488 282.52 18.9043C282.176 19.2559 281.766 19.5273 281.289 19.7188C280.816 19.9062 280.287 20 279.701 20ZM278.693 11.4688V20H277.223V11.4688H278.693Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.906 33.4554V44.8695H267.023V35.6898L264.234 36.6351V35.0804L268.68 33.4554H268.906ZM280.695 40.8148V42.3148H272.492L272.43 41.182L277.336 33.4945H278.844L277.211 36.2914L274.391 40.8148H280.695ZM279.273 33.4945V44.8695H277.391V33.4945H279.273Z",
    fill: "#3D4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.377 11.4688V20H352.918V11.4688H354.377ZM357.055 11.4688V12.6406H350.264V11.4688H357.055ZM363.816 15.0312V16.1973H359.287V15.0312H363.816ZM359.65 11.4688V20H358.18V11.4688H359.65ZM364.947 11.4688V20H363.482V11.4688H364.947ZM371.486 11.4688H372.951V17.1699C372.951 17.8184 372.811 18.3613 372.529 18.7988C372.248 19.2363 371.865 19.5664 371.381 19.7891C370.9 20.0078 370.363 20.1172 369.77 20.1172C369.156 20.1172 368.609 20.0078 368.129 19.7891C367.648 19.5664 367.27 19.2363 366.992 18.7988C366.719 18.3613 366.582 17.8184 366.582 17.1699V11.4688H368.047V17.1699C368.047 17.5801 368.117 17.918 368.258 18.1836C368.398 18.4453 368.598 18.6387 368.855 18.7637C369.113 18.8887 369.418 18.9512 369.77 18.9512C370.121 18.9512 370.424 18.8887 370.678 18.7637C370.936 18.6387 371.135 18.4453 371.275 18.1836C371.416 17.918 371.486 17.5801 371.486 17.1699V11.4688Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.906 33.4554V44.8695H357.023V35.6898L354.234 36.6351V35.0804L358.68 33.4554H358.906ZM364.836 39.5804L363.336 39.2133L363.953 33.4945H370.086V35.0883H365.516L365.203 37.8773C365.38 37.7732 365.625 37.6716 365.938 37.5726C366.25 37.4685 366.607 37.4164 367.008 37.4164C367.544 37.4164 368.023 37.5049 368.445 37.682C368.872 37.8539 369.234 38.1065 369.531 38.4398C369.828 38.7679 370.055 39.169 370.211 39.6429C370.367 40.1117 370.445 40.6403 370.445 41.2289C370.445 41.7549 370.367 42.2471 370.211 42.7054C370.06 43.1638 369.831 43.5674 369.523 43.9164C369.216 44.2653 368.828 44.5388 368.359 44.7367C367.896 44.9294 367.346 45.0258 366.711 45.0258C366.237 45.0258 365.781 44.958 365.344 44.8226C364.911 44.682 364.523 44.4763 364.18 44.2054C363.836 43.9294 363.56 43.5909 363.352 43.1898C363.143 42.7836 363.023 42.3174 362.992 41.7914H364.836C364.883 42.1612 364.984 42.4763 365.141 42.7367C365.302 42.9919 365.516 43.1872 365.781 43.3226C366.047 43.458 366.354 43.5258 366.703 43.5258C367.021 43.5258 367.294 43.4711 367.523 43.3617C367.753 43.2471 367.943 43.0857 368.094 42.8773C368.25 42.6638 368.365 42.4138 368.438 42.1273C368.516 41.8409 368.555 41.5232 368.555 41.1742C368.555 40.8409 368.51 40.5362 368.422 40.2601C368.339 39.9841 368.211 39.7445 368.039 39.5414C367.872 39.3383 367.661 39.182 367.406 39.0726C367.151 38.958 366.857 38.9008 366.523 38.9008C366.076 38.9008 365.732 38.9659 365.492 39.0961C365.258 39.2263 365.039 39.3877 364.836 39.5804Z",
    fill: "#3D4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.338 11.4688V20H443.867V11.4688H445.338ZM448.818 15.2012V16.3672H444.963V15.2012H448.818ZM449.305 11.4688V12.6406H444.963V11.4688H449.305ZM450.477 11.4688H453.494C454.143 11.4688 454.695 11.5664 455.152 11.7617C455.609 11.957 455.959 12.2461 456.201 12.6289C456.447 13.0078 456.57 13.4766 456.57 14.0352C456.57 14.4609 456.492 14.8359 456.336 15.1602C456.18 15.4844 455.959 15.7578 455.674 15.9805C455.389 16.1992 455.049 16.3691 454.654 16.4902L454.209 16.707H451.496L451.484 15.541H453.518C453.869 15.541 454.162 15.4785 454.396 15.3535C454.631 15.2285 454.807 15.0586 454.924 14.8438C455.045 14.625 455.105 14.3789 455.105 14.1055C455.105 13.8086 455.047 13.5508 454.93 13.332C454.816 13.1094 454.641 12.9395 454.402 12.8223C454.164 12.7012 453.861 12.6406 453.494 12.6406H451.947V20H450.477V11.4688ZM455.346 20L453.342 16.168L454.883 16.1621L456.916 19.9238V20H455.346ZM459.605 11.4688V20H458.135V11.4688H459.605Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 39,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.906 33.4554V44.8695H447.023V35.6898L444.234 36.6351V35.0804L448.68 33.4554H448.906ZM458.547 33.4242H458.781V34.9633H458.648C457.977 34.9633 457.396 35.0674 456.906 35.2758C456.422 35.4841 456.023 35.7705 455.711 36.1351C455.398 36.4997 455.164 36.9268 455.008 37.4164C454.857 37.9008 454.781 38.4164 454.781 38.9633V40.7523C454.781 41.2054 454.831 41.6065 454.93 41.9554C455.029 42.2992 455.167 42.5883 455.344 42.8226C455.526 43.0518 455.734 43.2263 455.969 43.3461C456.203 43.4659 456.456 43.5258 456.727 43.5258C457.008 43.5258 457.263 43.4685 457.492 43.3539C457.721 43.2341 457.917 43.07 458.078 42.8617C458.24 42.6534 458.362 42.406 458.445 42.1195C458.529 41.833 458.57 41.5205 458.57 41.182C458.57 40.8591 458.529 40.557 458.445 40.2758C458.367 39.9893 458.25 39.7393 458.094 39.5258C457.938 39.307 457.742 39.1377 457.508 39.0179C457.279 38.8929 457.013 38.8304 456.711 38.8304C456.336 38.8304 455.995 38.919 455.688 39.0961C455.385 39.2732 455.141 39.5049 454.953 39.7914C454.771 40.0726 454.672 40.3721 454.656 40.6898L453.938 40.4554C453.979 39.9711 454.086 39.5362 454.258 39.1508C454.435 38.7653 454.667 38.4372 454.953 38.1664C455.24 37.8955 455.57 37.6898 455.945 37.5492C456.326 37.4034 456.742 37.3304 457.195 37.3304C457.747 37.3304 458.227 37.4346 458.633 37.6429C459.039 37.8513 459.375 38.1351 459.641 38.4945C459.911 38.8487 460.112 39.2549 460.242 39.7133C460.378 40.1664 460.445 40.6403 460.445 41.1351C460.445 41.682 460.362 42.1924 460.195 42.6664C460.029 43.1351 459.784 43.5466 459.461 43.9008C459.143 44.2549 458.755 44.531 458.297 44.7289C457.844 44.9268 457.328 45.0258 456.75 45.0258C456.141 45.0258 455.596 44.9086 455.117 44.6742C454.643 44.4398 454.24 44.1169 453.906 43.7054C453.578 43.294 453.328 42.82 453.156 42.2836C452.984 41.7471 452.898 41.1794 452.898 40.5804V39.7992C452.898 38.9346 453.008 38.1195 453.227 37.3539C453.445 36.583 453.781 35.9034 454.234 35.3148C454.693 34.7263 455.279 34.2653 455.992 33.932C456.706 33.5935 457.557 33.4242 458.547 33.4242Z",
    fill: "#3D4043"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 136,
    y: 257,
    width: 87,
    height: 54,
    rx: 4,
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.312 297.359L145 297.359L145 298.531L139.312 298.531L139.312 297.359ZM141.742 295.094L142.656 295.094L142.656 297.68L141.742 297.68L141.742 295.094ZM139.312 294.82L140.23 294.82L140.23 297.68L139.312 297.68L139.312 294.82ZM142.023 289.469L142.293 289.469C142.725 289.469 143.113 289.527 143.457 289.645C143.801 289.762 144.094 289.927 144.336 290.141C144.576 290.354 144.759 290.609 144.887 290.906C145.014 291.201 145.078 291.527 145.078 291.887C145.078 292.243 145.014 292.57 144.887 292.867C144.759 293.161 144.576 293.417 144.336 293.633C144.094 293.849 143.801 294.017 143.457 294.137C143.113 294.254 142.725 294.312 142.293 294.312L142.023 294.312C141.589 294.312 141.201 294.254 140.859 294.137C140.516 294.02 140.223 293.854 139.98 293.641C139.738 293.424 139.553 293.169 139.426 292.875C139.298 292.578 139.234 292.251 139.234 291.895C139.234 291.535 139.298 291.208 139.426 290.914C139.553 290.617 139.738 290.362 139.98 290.148C140.223 289.932 140.516 289.766 140.859 289.648C141.201 289.529 141.589 289.469 142.023 289.469ZM142.293 290.652L142.016 290.652C141.714 290.652 141.448 290.68 141.219 290.734C140.99 290.789 140.797 290.87 140.641 290.977C140.484 291.083 140.367 291.214 140.289 291.367C140.208 291.521 140.168 291.697 140.168 291.895C140.168 292.092 140.208 292.268 140.289 292.422C140.367 292.573 140.484 292.702 140.641 292.809C140.797 292.913 140.99 292.992 141.219 293.047C141.448 293.102 141.714 293.129 142.016 293.129L142.293 293.129C142.592 293.129 142.858 293.102 143.09 293.047C143.319 292.992 143.513 292.911 143.672 292.805C143.828 292.698 143.947 292.568 144.027 292.414C144.108 292.26 144.148 292.085 144.148 291.887C144.148 291.689 144.108 291.513 144.027 291.359C143.947 291.206 143.828 291.077 143.672 290.973C143.513 290.868 143.319 290.789 143.09 290.734C142.858 290.68 142.592 290.652 142.293 290.652ZM143.113 285.328L143.113 284.16C143.496 284.184 143.836 284.289 144.133 284.477C144.43 284.661 144.661 284.921 144.828 285.254C144.995 285.585 145.078 285.983 145.078 286.449C145.078 286.814 145.016 287.141 144.891 287.43C144.763 287.719 144.581 287.966 144.344 288.172C144.107 288.375 143.82 288.53 143.484 288.637C143.148 288.743 142.772 288.797 142.355 288.797L141.961 288.797C141.544 288.797 141.168 288.742 140.832 288.633C140.493 288.521 140.206 288.362 139.969 288.156C139.732 287.948 139.549 287.699 139.422 287.41C139.294 287.121 139.23 286.798 139.23 286.441C139.23 285.967 139.316 285.568 139.488 285.242C139.66 284.914 139.897 284.66 140.199 284.48C140.501 284.298 140.845 284.189 141.23 284.152L141.23 285.324C141.001 285.337 140.807 285.383 140.648 285.461C140.487 285.539 140.366 285.658 140.285 285.816C140.202 285.973 140.16 286.181 140.16 286.441C140.16 286.637 140.197 286.807 140.27 286.953C140.342 287.099 140.453 287.221 140.602 287.32C140.75 287.419 140.937 287.493 141.164 287.543C141.388 287.59 141.651 287.613 141.953 287.613L142.355 287.613C142.65 287.613 142.909 287.591 143.133 287.547C143.354 287.503 143.542 287.435 143.695 287.344C143.846 287.25 143.961 287.13 144.039 286.984C144.115 286.836 144.152 286.658 144.152 286.449C144.152 286.204 144.113 286.003 144.035 285.844C143.957 285.685 143.841 285.564 143.687 285.48C143.534 285.395 143.342 285.344 143.113 285.328ZM139.312 280.25L139.312 279.082L143.07 279.082C143.508 279.082 143.876 279.176 144.176 279.363C144.475 279.548 144.701 279.805 144.852 280.133C145.003 280.458 145.078 280.833 145.078 281.258C145.078 281.682 145.003 282.06 144.852 282.391C144.701 282.719 144.475 282.977 144.176 283.164C143.876 283.349 143.508 283.441 143.07 283.441L139.312 283.441L139.312 282.27L143.07 282.27C143.326 282.27 143.534 282.229 143.695 282.148C143.857 282.068 143.975 281.952 144.051 281.801C144.126 281.647 144.164 281.466 144.164 281.258C144.164 281.044 144.126 280.863 144.051 280.715C143.975 280.564 143.857 280.449 143.695 280.371C143.534 280.29 143.326 280.25 143.07 280.25L139.312 280.25ZM143.512 275.156C143.41 275.156 143.319 275.172 143.238 275.203C143.155 275.232 143.079 275.286 143.012 275.367C142.941 275.448 142.872 275.561 142.805 275.707C142.737 275.853 142.667 276.042 142.594 276.273C142.51 276.531 142.417 276.776 142.312 277.008C142.208 277.237 142.087 277.44 141.949 277.617C141.809 277.792 141.646 277.93 141.461 278.031C141.276 278.13 141.061 278.18 140.816 278.18C140.579 278.18 140.365 278.128 140.172 278.023C139.977 277.919 139.81 277.773 139.672 277.586C139.531 277.398 139.423 277.177 139.348 276.922C139.272 276.664 139.234 276.382 139.234 276.074C139.234 275.655 139.31 275.289 139.461 274.977C139.612 274.664 139.819 274.422 140.082 274.25C140.345 274.076 140.646 273.988 140.984 273.988L140.984 275.152C140.818 275.152 140.672 275.187 140.547 275.258C140.419 275.326 140.319 275.43 140.246 275.57C140.173 275.708 140.137 275.883 140.137 276.094C140.137 276.297 140.168 276.466 140.23 276.602C140.29 276.737 140.372 276.839 140.477 276.906C140.578 276.974 140.693 277.008 140.82 277.008C140.917 277.008 141.004 276.984 141.082 276.937C141.16 276.888 141.233 276.815 141.301 276.719C141.368 276.622 141.432 276.504 141.492 276.363C141.552 276.223 141.611 276.06 141.668 275.875C141.762 275.565 141.867 275.293 141.984 275.059C142.102 274.822 142.233 274.624 142.379 274.465C142.525 274.306 142.69 274.186 142.875 274.105C143.06 274.025 143.27 273.984 143.504 273.984C143.751 273.984 143.973 274.033 144.168 274.129C144.363 274.225 144.529 274.365 144.664 274.547C144.799 274.729 144.902 274.947 144.973 275.199C145.043 275.452 145.078 275.734 145.078 276.047C145.078 276.328 145.042 276.605 144.969 276.879C144.893 277.152 144.78 277.401 144.629 277.625C144.478 277.846 144.285 278.023 144.051 278.156C143.816 278.289 143.539 278.355 143.219 278.355L143.219 277.18C143.396 277.18 143.546 277.152 143.668 277.098C143.79 277.043 143.889 276.966 143.965 276.867C144.04 276.766 144.095 276.646 144.129 276.508C144.163 276.367 144.18 276.214 144.18 276.047C144.18 275.844 144.151 275.677 144.094 275.547C144.036 275.414 143.957 275.316 143.855 275.254C143.754 275.189 143.639 275.156 143.512 275.156ZM145 269.449L145 270.687L144.086 270.68L144.086 269.449C144.086 269.142 144.017 268.883 143.879 268.672C143.738 268.461 143.534 268.302 143.266 268.195C142.997 268.086 142.673 268.031 142.293 268.031L142.016 268.031C141.724 268.031 141.467 268.062 141.246 268.125C141.025 268.185 140.839 268.275 140.687 268.395C140.536 268.514 140.423 268.661 140.348 268.836C140.27 269.01 140.23 269.211 140.23 269.437L140.23 270.711L139.312 270.711L139.312 269.437C139.312 269.057 139.378 268.71 139.508 268.395C139.635 268.077 139.819 267.802 140.059 267.57C140.298 267.339 140.585 267.16 140.918 267.035C141.249 266.908 141.617 266.844 142.023 266.844L142.293 266.844C142.697 266.844 143.065 266.908 143.398 267.035C143.732 267.16 144.018 267.339 144.258 267.57C144.495 267.799 144.678 268.074 144.809 268.395C144.936 268.712 145 269.064 145 269.449ZM139.312 270.023L145 270.023L145 271.195L139.312 271.195L139.312 270.023ZM139.312 264.746L145 264.746L145 265.914L139.312 265.914L139.312 264.746ZM142.973 261.434L142.973 262.883L142.059 262.883L142.059 261.434C142.059 261.21 142.022 261.027 141.949 260.887C141.874 260.746 141.77 260.643 141.637 260.578C141.504 260.513 141.354 260.48 141.187 260.48C141.018 260.48 140.861 260.513 140.715 260.578C140.569 260.643 140.452 260.746 140.363 260.887C140.275 261.027 140.23 261.21 140.23 261.434L140.23 262.477L145 262.477L145 263.648L139.312 263.648L139.312 261.434C139.312 260.988 139.393 260.607 139.555 260.289C139.714 259.969 139.934 259.724 140.215 259.555C140.496 259.385 140.818 259.301 141.18 259.301C141.547 259.301 141.865 259.385 142.133 259.555C142.401 259.724 142.608 259.969 142.754 260.289C142.9 260.607 142.973 260.988 142.973 261.434Z",
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 226,
    y: 94,
    width: 87,
    height: 71,
    rx: 4,
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 144.948L235 143.86L232.664 143.86L232.664 141.908L231.576 141.908L231.576 143.86L230.328 143.86L230.328 141.428L229.24 141.428L229.24 144.948L235 144.948ZM235.12 138.234C235.12 136.506 233.912 135.442 232.12 135.442C230.328 135.442 229.12 136.506 229.12 138.234C229.12 139.962 230.328 141.026 232.12 141.026C233.912 141.026 235.12 139.962 235.12 138.234ZM232.12 139.874C230.92 139.874 230.128 139.33 230.144 138.234C230.16 137.138 230.92 136.594 232.12 136.594C233.32 136.594 234.112 137.138 234.096 138.234C234.08 139.33 233.32 139.874 232.12 139.874ZM235.12 132.171C235.12 130.851 234.416 129.923 233.296 129.555L232.992 130.651C233.688 130.867 234.096 131.371 234.096 132.171C234.096 133.267 233.32 133.819 232.12 133.819C230.92 133.819 230.144 133.267 230.144 132.171C230.144 131.371 230.552 130.867 231.248 130.651L230.944 129.555C229.824 129.923 229.12 130.851 229.12 132.171C229.12 133.899 230.328 134.963 232.12 134.963C233.912 134.963 235.12 133.899 235.12 132.171ZM235.12 126.33C235.12 124.938 234.224 123.986 232.84 123.986L229.24 123.986L229.24 125.09L232.832 125.09C233.576 125.09 234.096 125.626 234.096 126.33C234.096 127.018 233.592 127.57 232.832 127.57L229.24 127.57L229.248 128.674L232.84 128.674C234.224 128.674 235.12 127.722 235.12 126.33ZM235.12 120.936C235.12 119.76 234.528 118.624 233.288 118.624C232.128 118.624 231.84 119.624 231.68 120.216L231.408 121.216C231.312 121.584 231.168 121.984 230.792 121.984C230.384 121.984 230.128 121.504 230.144 120.992C230.16 120.472 230.456 119.976 231.016 119.848L230.816 118.672C229.736 118.952 229.144 119.784 229.128 120.976C229.12 122.16 229.688 123.128 230.848 123.128C231.944 123.128 232.224 122.272 232.352 121.824L232.792 120.328C232.928 119.88 233.136 119.768 233.368 119.768C233.848 119.768 234.104 120.328 234.104 120.864C234.104 121.504 233.736 122.056 233.072 122.216L233.24 123.352C234.408 123.176 235.12 122.216 235.12 120.936ZM235 116.143L235 115.055L233.048 115.055L233.048 113.711C233.048 113.607 233.04 113.383 233.016 113.231C232.856 112.207 232.112 111.743 231.144 111.743C230.176 111.743 229.432 112.199 229.272 113.231C229.248 113.383 229.24 113.599 229.24 113.711L229.24 116.143L235 116.143ZM232.032 115.055L230.256 115.055L230.256 113.759C230.256 113.647 230.264 113.503 230.296 113.391C230.416 112.951 230.832 112.839 231.144 112.839C231.456 112.839 231.872 112.951 231.992 113.391C232.024 113.503 232.032 113.647 232.032 113.759L232.032 115.055ZM235 110.94L235 107.18L233.984 107.18L233.984 109.852L232.504 109.852L232.504 107.66L231.488 107.66L231.488 109.852L230.256 109.852L230.256 107.18L229.24 107.18L229.24 110.94L235 110.94ZM235 106.621L235 105.501L233.8 105.137L233.8 102.969L235 102.597L235 101.477L229.24 103.237L229.24 104.861L235 106.621ZM232.784 104.829L230.26 104.061L232.784 103.281L232.784 104.829ZM235 100.76L235 99.6723L232.376 99.6723L235 97.3763L235 96.0003L232.08 98.5603L229.24 96.1523L229.24 97.4803L231.896 99.6723L229.24 99.6723L229.24 100.76L235 100.76Z",
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 226,
    y: 272,
    width: 87,
    height: 71,
    rx: 4,
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.312 312.359L235 312.359L235 313.531L229.312 313.531L229.312 312.359ZM231.742 310.094L232.656 310.094L232.656 312.68L231.742 312.68L231.742 310.094ZM229.312 309.82L230.23 309.82L230.23 312.68L229.312 312.68L229.312 309.82ZM232.023 304.469L232.293 304.469C232.725 304.469 233.113 304.527 233.457 304.645C233.801 304.762 234.094 304.927 234.336 305.141C234.576 305.354 234.759 305.609 234.887 305.906C235.014 306.201 235.078 306.527 235.078 306.887C235.078 307.243 235.014 307.57 234.887 307.867C234.759 308.161 234.576 308.417 234.336 308.633C234.094 308.849 233.801 309.017 233.457 309.137C233.113 309.254 232.725 309.312 232.293 309.312L232.023 309.312C231.589 309.312 231.201 309.254 230.859 309.137C230.516 309.02 230.223 308.854 229.98 308.641C229.738 308.424 229.553 308.169 229.426 307.875C229.298 307.578 229.234 307.251 229.234 306.895C229.234 306.535 229.298 306.208 229.426 305.914C229.553 305.617 229.738 305.362 229.98 305.148C230.223 304.932 230.516 304.766 230.859 304.648C231.201 304.529 231.589 304.469 232.023 304.469ZM232.293 305.652L232.016 305.652C231.714 305.652 231.448 305.68 231.219 305.734C230.99 305.789 230.797 305.87 230.641 305.977C230.484 306.083 230.367 306.214 230.289 306.367C230.208 306.521 230.168 306.697 230.168 306.895C230.168 307.092 230.208 307.268 230.289 307.422C230.367 307.573 230.484 307.702 230.641 307.809C230.797 307.913 230.99 307.992 231.219 308.047C231.448 308.102 231.714 308.129 232.016 308.129L232.293 308.129C232.592 308.129 232.858 308.102 233.09 308.047C233.319 307.992 233.513 307.911 233.672 307.805C233.828 307.698 233.947 307.568 234.027 307.414C234.108 307.26 234.148 307.085 234.148 306.887C234.148 306.689 234.108 306.513 234.027 306.359C233.947 306.206 233.828 306.077 233.672 305.973C233.513 305.868 233.319 305.789 233.09 305.734C232.858 305.68 232.592 305.652 232.293 305.652ZM233.113 300.328L233.113 299.16C233.496 299.184 233.836 299.289 234.133 299.477C234.43 299.661 234.661 299.921 234.828 300.254C234.995 300.585 235.078 300.983 235.078 301.449C235.078 301.814 235.016 302.141 234.891 302.43C234.763 302.719 234.581 302.966 234.344 303.172C234.107 303.375 233.82 303.53 233.484 303.637C233.148 303.743 232.772 303.797 232.355 303.797L231.961 303.797C231.544 303.797 231.168 303.742 230.832 303.633C230.493 303.521 230.206 303.362 229.969 303.156C229.732 302.948 229.549 302.699 229.422 302.41C229.294 302.121 229.23 301.798 229.23 301.441C229.23 300.967 229.316 300.568 229.488 300.242C229.66 299.914 229.897 299.66 230.199 299.48C230.501 299.298 230.845 299.189 231.23 299.152L231.23 300.324C231.001 300.337 230.807 300.383 230.648 300.461C230.487 300.539 230.366 300.658 230.285 300.816C230.202 300.973 230.16 301.181 230.16 301.441C230.16 301.637 230.197 301.807 230.27 301.953C230.342 302.099 230.453 302.221 230.602 302.32C230.75 302.419 230.937 302.493 231.164 302.543C231.388 302.59 231.651 302.613 231.953 302.613L232.355 302.613C232.65 302.613 232.909 302.591 233.133 302.547C233.354 302.503 233.542 302.435 233.695 302.344C233.846 302.25 233.961 302.13 234.039 301.984C234.115 301.836 234.152 301.658 234.152 301.449C234.152 301.204 234.113 301.003 234.035 300.844C233.957 300.685 233.841 300.564 233.687 300.48C233.534 300.395 233.342 300.344 233.113 300.328ZM229.312 295.25L229.312 294.082L233.07 294.082C233.508 294.082 233.876 294.176 234.176 294.363C234.475 294.548 234.701 294.805 234.852 295.133C235.003 295.458 235.078 295.833 235.078 296.258C235.078 296.682 235.003 297.06 234.852 297.391C234.701 297.719 234.475 297.977 234.176 298.164C233.876 298.349 233.508 298.441 233.07 298.441L229.312 298.441L229.312 297.27L233.07 297.27C233.326 297.27 233.534 297.229 233.695 297.148C233.857 297.068 233.975 296.952 234.051 296.801C234.126 296.647 234.164 296.466 234.164 296.258C234.164 296.044 234.126 295.863 234.051 295.715C233.975 295.564 233.857 295.449 233.695 295.371C233.534 295.29 233.326 295.25 233.07 295.25L229.312 295.25ZM233.512 290.156C233.41 290.156 233.319 290.172 233.238 290.203C233.155 290.232 233.079 290.286 233.012 290.367C232.941 290.448 232.872 290.561 232.805 290.707C232.737 290.853 232.667 291.042 232.594 291.273C232.51 291.531 232.417 291.776 232.312 292.008C232.208 292.237 232.087 292.44 231.949 292.617C231.809 292.792 231.646 292.93 231.461 293.031C231.276 293.13 231.061 293.18 230.816 293.18C230.579 293.18 230.365 293.128 230.172 293.023C229.977 292.919 229.81 292.773 229.672 292.586C229.531 292.398 229.423 292.177 229.348 291.922C229.272 291.664 229.234 291.382 229.234 291.074C229.234 290.655 229.31 290.289 229.461 289.977C229.612 289.664 229.819 289.422 230.082 289.25C230.345 289.076 230.646 288.988 230.984 288.988L230.984 290.152C230.818 290.152 230.672 290.187 230.547 290.258C230.419 290.326 230.319 290.43 230.246 290.57C230.173 290.708 230.137 290.883 230.137 291.094C230.137 291.297 230.168 291.466 230.23 291.602C230.29 291.737 230.372 291.839 230.477 291.906C230.578 291.974 230.693 292.008 230.82 292.008C230.917 292.008 231.004 291.984 231.082 291.937C231.16 291.888 231.233 291.815 231.301 291.719C231.368 291.622 231.432 291.504 231.492 291.363C231.552 291.223 231.611 291.06 231.668 290.875C231.762 290.565 231.867 290.293 231.984 290.059C232.102 289.822 232.233 289.624 232.379 289.465C232.525 289.306 232.69 289.186 232.875 289.105C233.06 289.025 233.27 288.984 233.504 288.984C233.751 288.984 233.973 289.033 234.168 289.129C234.363 289.225 234.529 289.365 234.664 289.547C234.799 289.729 234.902 289.947 234.973 290.199C235.043 290.452 235.078 290.734 235.078 291.047C235.078 291.328 235.042 291.605 234.969 291.879C234.893 292.152 234.78 292.401 234.629 292.625C234.478 292.846 234.285 293.023 234.051 293.156C233.816 293.289 233.539 293.355 233.219 293.355L233.219 292.18C233.396 292.18 233.546 292.152 233.668 292.098C233.79 292.043 233.889 291.966 233.965 291.867C234.04 291.766 234.095 291.646 234.129 291.508C234.163 291.367 234.18 291.214 234.18 291.047C234.18 290.844 234.151 290.677 234.094 290.547C234.036 290.414 233.957 290.316 233.855 290.254C233.754 290.189 233.639 290.156 233.512 290.156ZM235 284.449L235 285.687L234.086 285.68L234.086 284.449C234.086 284.142 234.017 283.883 233.879 283.672C233.738 283.461 233.534 283.302 233.266 283.195C232.997 283.086 232.673 283.031 232.293 283.031L232.016 283.031C231.724 283.031 231.467 283.062 231.246 283.125C231.025 283.185 230.839 283.275 230.687 283.395C230.536 283.514 230.423 283.661 230.348 283.836C230.27 284.01 230.23 284.211 230.23 284.437L230.23 285.711L229.312 285.711L229.312 284.437C229.312 284.057 229.378 283.71 229.508 283.395C229.635 283.077 229.819 282.802 230.059 282.57C230.298 282.339 230.585 282.16 230.918 282.035C231.249 281.908 231.617 281.844 232.023 281.844L232.293 281.844C232.697 281.844 233.065 281.908 233.398 282.035C233.732 282.16 234.018 282.339 234.258 282.57C234.495 282.799 234.678 283.074 234.809 283.395C234.936 283.712 235 284.064 235 284.449ZM229.312 285.023L235 285.023L235 286.195L229.312 286.195L229.312 285.023ZM229.312 279.746L235 279.746L235 280.914L229.312 280.914L229.312 279.746ZM232.973 276.434L232.973 277.883L232.059 277.883L232.059 276.434C232.059 276.21 232.022 276.027 231.949 275.887C231.874 275.746 231.77 275.643 231.637 275.578C231.504 275.513 231.354 275.48 231.187 275.48C231.018 275.48 230.861 275.513 230.715 275.578C230.569 275.643 230.452 275.746 230.363 275.887C230.275 276.027 230.23 276.21 230.23 276.434L230.23 277.477L235 277.477L235 278.648L229.312 278.648L229.312 276.434C229.312 275.988 229.393 275.607 229.555 275.289C229.714 274.969 229.934 274.724 230.215 274.555C230.496 274.385 230.818 274.301 231.18 274.301C231.547 274.301 231.865 274.385 232.133 274.555C232.401 274.724 232.608 274.969 232.754 275.289C232.9 275.607 232.973 275.988 232.973 276.434Z",
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 316,
    y: 82,
    width: 87,
    height: 54,
    rx: 4,
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 132.948L325 131.86L322.664 131.86L322.664 129.908L321.576 129.908L321.576 131.86L320.328 131.86L320.328 129.428L319.24 129.428L319.24 132.948L325 132.948ZM325.12 126.234C325.12 124.506 323.912 123.442 322.12 123.442C320.328 123.442 319.12 124.506 319.12 126.234C319.12 127.962 320.328 129.026 322.12 129.026C323.912 129.026 325.12 127.962 325.12 126.234ZM322.12 127.874C320.92 127.874 320.128 127.33 320.144 126.234C320.16 125.138 320.92 124.594 322.12 124.594C323.32 124.594 324.112 125.138 324.096 126.234C324.08 127.33 323.32 127.874 322.12 127.874ZM325.12 120.171C325.12 118.851 324.416 117.923 323.296 117.555L322.992 118.651C323.688 118.867 324.096 119.371 324.096 120.171C324.096 121.267 323.32 121.819 322.12 121.819C320.92 121.819 320.144 121.267 320.144 120.171C320.144 119.371 320.552 118.867 321.248 118.651L320.944 117.555C319.824 117.923 319.12 118.851 319.12 120.171C319.12 121.899 320.328 122.963 322.12 122.963C323.912 122.963 325.12 121.899 325.12 120.171ZM325.12 114.33C325.12 112.938 324.224 111.986 322.84 111.986L319.24 111.986L319.24 113.09L322.832 113.09C323.576 113.09 324.096 113.626 324.096 114.33C324.096 115.018 323.592 115.57 322.832 115.57L319.24 115.57L319.248 116.674L322.84 116.674C324.224 116.674 325.12 115.722 325.12 114.33ZM325.12 108.936C325.12 107.76 324.528 106.624 323.288 106.624C322.128 106.624 321.84 107.624 321.68 108.216L321.408 109.216C321.312 109.584 321.168 109.984 320.792 109.984C320.384 109.984 320.128 109.504 320.144 108.992C320.16 108.472 320.456 107.976 321.016 107.848L320.816 106.672C319.736 106.952 319.144 107.784 319.128 108.976C319.12 110.16 319.688 111.128 320.848 111.128C321.944 111.128 322.224 110.272 322.352 109.824L322.792 108.328C322.928 107.88 323.136 107.768 323.368 107.768C323.848 107.768 324.104 108.328 324.104 108.864C324.104 109.504 323.736 110.056 323.072 110.216L323.24 111.352C324.408 111.176 325.12 110.216 325.12 108.936ZM325 104.143L325 103.055L323.048 103.055L323.048 101.711C323.048 101.607 323.04 101.383 323.016 101.231C322.856 100.207 322.112 99.7431 321.144 99.7431C320.176 99.7431 319.432 100.199 319.272 101.231C319.248 101.383 319.24 101.599 319.24 101.711L319.24 104.143L325 104.143ZM322.032 103.055L320.256 103.055L320.256 101.759C320.256 101.647 320.264 101.503 320.296 101.391C320.416 100.951 320.832 100.839 321.144 100.839C321.456 100.839 321.872 100.951 321.992 101.391C322.024 101.503 322.032 101.647 322.032 101.759L322.032 103.055ZM325 98.94L325 95.18L323.984 95.18L323.984 97.852L322.504 97.852L322.504 95.66L321.488 95.66L321.488 97.852L320.256 97.852L320.256 95.18L319.24 95.18L319.24 98.94L325 98.94ZM325 94.6212L325 93.5012L323.8 93.1372L323.8 90.9692L325 90.5972L325 89.4772L319.24 91.2372L319.24 92.8612L325 94.6212ZM322.784 92.8292L320.26 92.0612L322.784 91.2812L322.784 92.8292ZM325 88.7603L325 87.6723L322.376 87.6723L325 85.3763L325 84.0003L322.08 86.5603L319.24 84.1523L319.24 85.4803L321.896 87.6723L319.24 87.6723L319.24 88.7603L325 88.7603Z",
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 316,
    y: 260,
    width: 87,
    height: 54,
    rx: 4,
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.312 300.359L325 300.359L325 301.531L319.312 301.531L319.312 300.359ZM321.742 298.094L322.656 298.094L322.656 300.68L321.742 300.68L321.742 298.094ZM319.312 297.82L320.23 297.82L320.23 300.68L319.312 300.68L319.312 297.82ZM322.023 292.469L322.293 292.469C322.725 292.469 323.113 292.527 323.457 292.645C323.801 292.762 324.094 292.927 324.336 293.141C324.576 293.354 324.759 293.609 324.887 293.906C325.014 294.201 325.078 294.527 325.078 294.887C325.078 295.243 325.014 295.57 324.887 295.867C324.759 296.161 324.576 296.417 324.336 296.633C324.094 296.849 323.801 297.017 323.457 297.137C323.113 297.254 322.725 297.312 322.293 297.312L322.023 297.312C321.589 297.312 321.201 297.254 320.859 297.137C320.516 297.02 320.223 296.854 319.98 296.641C319.738 296.424 319.553 296.169 319.426 295.875C319.298 295.578 319.234 295.251 319.234 294.895C319.234 294.535 319.298 294.208 319.426 293.914C319.553 293.617 319.738 293.362 319.98 293.148C320.223 292.932 320.516 292.766 320.859 292.648C321.201 292.529 321.589 292.469 322.023 292.469ZM322.293 293.652L322.016 293.652C321.714 293.652 321.448 293.68 321.219 293.734C320.99 293.789 320.797 293.87 320.641 293.977C320.484 294.083 320.367 294.214 320.289 294.367C320.208 294.521 320.168 294.697 320.168 294.895C320.168 295.092 320.208 295.268 320.289 295.422C320.367 295.573 320.484 295.702 320.641 295.809C320.797 295.913 320.99 295.992 321.219 296.047C321.448 296.102 321.714 296.129 322.016 296.129L322.293 296.129C322.592 296.129 322.858 296.102 323.09 296.047C323.319 295.992 323.513 295.911 323.672 295.805C323.828 295.698 323.947 295.568 324.027 295.414C324.108 295.26 324.148 295.085 324.148 294.887C324.148 294.689 324.108 294.513 324.027 294.359C323.947 294.206 323.828 294.077 323.672 293.973C323.513 293.868 323.319 293.789 323.09 293.734C322.858 293.68 322.592 293.652 322.293 293.652ZM323.113 288.328L323.113 287.16C323.496 287.184 323.836 287.289 324.133 287.477C324.43 287.661 324.661 287.921 324.828 288.254C324.995 288.585 325.078 288.983 325.078 289.449C325.078 289.814 325.016 290.141 324.891 290.43C324.763 290.719 324.581 290.966 324.344 291.172C324.107 291.375 323.82 291.53 323.484 291.637C323.148 291.743 322.772 291.797 322.355 291.797L321.961 291.797C321.544 291.797 321.168 291.742 320.832 291.633C320.493 291.521 320.206 291.362 319.969 291.156C319.732 290.948 319.549 290.699 319.422 290.41C319.294 290.121 319.23 289.798 319.23 289.441C319.23 288.967 319.316 288.568 319.488 288.242C319.66 287.914 319.897 287.66 320.199 287.48C320.501 287.298 320.845 287.189 321.23 287.152L321.23 288.324C321.001 288.337 320.807 288.383 320.648 288.461C320.487 288.539 320.366 288.658 320.285 288.816C320.202 288.973 320.16 289.181 320.16 289.441C320.16 289.637 320.197 289.807 320.27 289.953C320.342 290.099 320.453 290.221 320.602 290.32C320.75 290.419 320.937 290.493 321.164 290.543C321.388 290.59 321.651 290.613 321.953 290.613L322.355 290.613C322.65 290.613 322.909 290.591 323.133 290.547C323.354 290.503 323.542 290.435 323.695 290.344C323.846 290.25 323.961 290.13 324.039 289.984C324.115 289.836 324.152 289.658 324.152 289.449C324.152 289.204 324.113 289.003 324.035 288.844C323.957 288.685 323.841 288.564 323.687 288.48C323.534 288.395 323.342 288.344 323.113 288.328ZM319.312 283.25L319.312 282.082L323.07 282.082C323.508 282.082 323.876 282.176 324.176 282.363C324.475 282.548 324.701 282.805 324.852 283.133C325.003 283.458 325.078 283.833 325.078 284.258C325.078 284.682 325.003 285.06 324.852 285.391C324.701 285.719 324.475 285.977 324.176 286.164C323.876 286.349 323.508 286.441 323.07 286.441L319.312 286.441L319.312 285.27L323.07 285.27C323.326 285.27 323.534 285.229 323.695 285.148C323.857 285.068 323.975 284.952 324.051 284.801C324.126 284.647 324.164 284.466 324.164 284.258C324.164 284.044 324.126 283.863 324.051 283.715C323.975 283.564 323.857 283.449 323.695 283.371C323.534 283.29 323.326 283.25 323.07 283.25L319.312 283.25ZM323.512 278.156C323.41 278.156 323.319 278.172 323.238 278.203C323.155 278.232 323.079 278.286 323.012 278.367C322.941 278.448 322.872 278.561 322.805 278.707C322.737 278.853 322.667 279.042 322.594 279.273C322.51 279.531 322.417 279.776 322.312 280.008C322.208 280.237 322.087 280.44 321.949 280.617C321.809 280.792 321.646 280.93 321.461 281.031C321.276 281.13 321.061 281.18 320.816 281.18C320.579 281.18 320.365 281.128 320.172 281.023C319.977 280.919 319.81 280.773 319.672 280.586C319.531 280.398 319.423 280.177 319.348 279.922C319.272 279.664 319.234 279.382 319.234 279.074C319.234 278.655 319.31 278.289 319.461 277.977C319.612 277.664 319.819 277.422 320.082 277.25C320.345 277.076 320.646 276.988 320.984 276.988L320.984 278.152C320.818 278.152 320.672 278.187 320.547 278.258C320.419 278.326 320.319 278.43 320.246 278.57C320.173 278.708 320.137 278.883 320.137 279.094C320.137 279.297 320.168 279.466 320.23 279.602C320.29 279.737 320.372 279.839 320.477 279.906C320.578 279.974 320.693 280.008 320.82 280.008C320.917 280.008 321.004 279.984 321.082 279.937C321.16 279.888 321.233 279.815 321.301 279.719C321.368 279.622 321.432 279.504 321.492 279.363C321.552 279.223 321.611 279.06 321.668 278.875C321.762 278.565 321.867 278.293 321.984 278.059C322.102 277.822 322.233 277.624 322.379 277.465C322.525 277.306 322.69 277.186 322.875 277.105C323.06 277.025 323.27 276.984 323.504 276.984C323.751 276.984 323.973 277.033 324.168 277.129C324.363 277.225 324.529 277.365 324.664 277.547C324.799 277.729 324.902 277.947 324.973 278.199C325.043 278.452 325.078 278.734 325.078 279.047C325.078 279.328 325.042 279.605 324.969 279.879C324.893 280.152 324.78 280.401 324.629 280.625C324.478 280.846 324.285 281.023 324.051 281.156C323.816 281.289 323.539 281.355 323.219 281.355L323.219 280.18C323.396 280.18 323.546 280.152 323.668 280.098C323.79 280.043 323.889 279.966 323.965 279.867C324.04 279.766 324.095 279.646 324.129 279.508C324.163 279.367 324.18 279.214 324.18 279.047C324.18 278.844 324.151 278.677 324.094 278.547C324.036 278.414 323.957 278.316 323.855 278.254C323.754 278.189 323.639 278.156 323.512 278.156ZM325 272.449L325 273.687L324.086 273.68L324.086 272.449C324.086 272.142 324.017 271.883 323.879 271.672C323.738 271.461 323.534 271.302 323.266 271.195C322.997 271.086 322.673 271.031 322.293 271.031L322.016 271.031C321.724 271.031 321.467 271.062 321.246 271.125C321.025 271.185 320.839 271.275 320.687 271.395C320.536 271.514 320.423 271.661 320.348 271.836C320.27 272.01 320.23 272.211 320.23 272.437L320.23 273.711L319.312 273.711L319.312 272.437C319.312 272.057 319.378 271.71 319.508 271.395C319.635 271.077 319.819 270.802 320.059 270.57C320.298 270.339 320.585 270.16 320.918 270.035C321.249 269.908 321.617 269.844 322.023 269.844L322.293 269.844C322.697 269.844 323.065 269.908 323.398 270.035C323.732 270.16 324.018 270.339 324.258 270.57C324.495 270.799 324.678 271.074 324.809 271.395C324.936 271.712 325 272.064 325 272.449ZM319.312 273.023L325 273.023L325 274.195L319.312 274.195L319.312 273.023ZM319.312 267.746L325 267.746L325 268.914L319.312 268.914L319.312 267.746ZM322.973 264.434L322.973 265.883L322.059 265.883L322.059 264.434C322.059 264.21 322.022 264.027 321.949 263.887C321.874 263.746 321.77 263.643 321.637 263.578C321.504 263.513 321.354 263.48 321.187 263.48C321.018 263.48 320.861 263.513 320.715 263.578C320.569 263.643 320.452 263.746 320.363 263.887C320.275 264.027 320.23 264.21 320.23 264.434L320.23 265.477L325 265.477L325 266.648L319.312 266.648L319.312 264.434C319.312 263.988 319.393 263.607 319.555 263.289C319.714 262.969 319.934 262.724 320.215 262.555C320.496 262.385 320.818 262.301 321.18 262.301C321.547 262.301 321.865 262.385 322.133 262.555C322.401 262.724 322.608 262.969 322.754 263.289C322.9 263.607 322.973 263.988 322.973 264.434Z",
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 406,
    y: 89,
    width: 88,
    height: 62,
    rx: 4,
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 139.948L415 138.86L412.664 138.86L412.664 136.908L411.576 136.908L411.576 138.86L410.328 138.86L410.328 136.428L409.24 136.428L409.24 139.948L415 139.948ZM415.12 133.234C415.12 131.506 413.912 130.442 412.12 130.442C410.328 130.442 409.12 131.506 409.12 133.234C409.12 134.962 410.328 136.026 412.12 136.026C413.912 136.026 415.12 134.962 415.12 133.234ZM412.12 134.874C410.92 134.874 410.128 134.33 410.144 133.234C410.16 132.138 410.92 131.594 412.12 131.594C413.32 131.594 414.112 132.138 414.096 133.234C414.08 134.33 413.32 134.874 412.12 134.874ZM415.12 127.171C415.12 125.851 414.416 124.923 413.296 124.555L412.992 125.651C413.688 125.867 414.096 126.371 414.096 127.171C414.096 128.267 413.32 128.819 412.12 128.819C410.92 128.819 410.144 128.267 410.144 127.171C410.144 126.371 410.552 125.867 411.248 125.651L410.944 124.555C409.824 124.923 409.12 125.851 409.12 127.171C409.12 128.899 410.328 129.963 412.12 129.963C413.912 129.963 415.12 128.899 415.12 127.171ZM415.12 121.33C415.12 119.938 414.224 118.986 412.84 118.986L409.24 118.986L409.24 120.09L412.832 120.09C413.576 120.09 414.096 120.626 414.096 121.33C414.096 122.018 413.592 122.57 412.832 122.57L409.24 122.57L409.248 123.674L412.84 123.674C414.224 123.674 415.12 122.722 415.12 121.33ZM415.12 115.936C415.12 114.76 414.528 113.624 413.288 113.624C412.128 113.624 411.84 114.624 411.68 115.216L411.408 116.216C411.312 116.584 411.168 116.984 410.792 116.984C410.384 116.984 410.128 116.504 410.144 115.992C410.16 115.472 410.456 114.976 411.016 114.848L410.816 113.672C409.736 113.952 409.144 114.784 409.128 115.976C409.12 117.16 409.688 118.128 410.848 118.128C411.944 118.128 412.224 117.272 412.352 116.824L412.792 115.328C412.928 114.88 413.136 114.768 413.368 114.768C413.848 114.768 414.104 115.328 414.104 115.864C414.104 116.504 413.736 117.056 413.072 117.216L413.24 118.352C414.408 118.176 415.12 117.216 415.12 115.936ZM415 111.143L415 110.055L413.048 110.055L413.048 108.711C413.048 108.607 413.04 108.383 413.016 108.231C412.856 107.207 412.112 106.743 411.144 106.743C410.176 106.743 409.432 107.199 409.272 108.231C409.248 108.383 409.24 108.599 409.24 108.711L409.24 111.143L415 111.143ZM412.032 110.055L410.256 110.055L410.256 108.759C410.256 108.647 410.264 108.503 410.296 108.391C410.416 107.951 410.832 107.839 411.144 107.839C411.456 107.839 411.872 107.951 411.992 108.391C412.024 108.503 412.032 108.647 412.032 108.759L412.032 110.055ZM415 105.94L415 102.18L413.984 102.18L413.984 104.852L412.504 104.852L412.504 102.66L411.488 102.66L411.488 104.852L410.256 104.852L410.256 102.18L409.24 102.18L409.24 105.94L415 105.94ZM415 101.621L415 100.501L413.8 100.137L413.8 97.9692L415 97.5972L415 96.4772L409.24 98.2372L409.24 99.8612L415 101.621ZM412.784 99.8292L410.26 99.0612L412.784 98.2812L412.784 99.8292ZM415 95.7603L415 94.6723L412.376 94.6723L415 92.3763L415 91.0003L412.08 93.5603L409.24 91.1523L409.24 92.4803L411.896 94.6723L409.24 94.6723L409.24 95.7603L415 95.7603Z",
    fill: "#5F3FC0"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 406,
    y: 267,
    width: 88,
    height: 62,
    rx: 4,
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.312 307.359L415 307.359L415 308.531L409.312 308.531L409.312 307.359ZM411.742 305.094L412.656 305.094L412.656 307.68L411.742 307.68L411.742 305.094ZM409.312 304.82L410.23 304.82L410.23 307.68L409.312 307.68L409.312 304.82ZM412.023 299.469L412.293 299.469C412.725 299.469 413.113 299.527 413.457 299.645C413.801 299.762 414.094 299.927 414.336 300.141C414.576 300.354 414.759 300.609 414.887 300.906C415.014 301.201 415.078 301.527 415.078 301.887C415.078 302.243 415.014 302.57 414.887 302.867C414.759 303.161 414.576 303.417 414.336 303.633C414.094 303.849 413.801 304.017 413.457 304.137C413.113 304.254 412.725 304.312 412.293 304.312L412.023 304.312C411.589 304.312 411.201 304.254 410.859 304.137C410.516 304.02 410.223 303.854 409.98 303.641C409.738 303.424 409.553 303.169 409.426 302.875C409.298 302.578 409.234 302.251 409.234 301.895C409.234 301.535 409.298 301.208 409.426 300.914C409.553 300.617 409.738 300.362 409.98 300.148C410.223 299.932 410.516 299.766 410.859 299.648C411.201 299.529 411.589 299.469 412.023 299.469ZM412.293 300.652L412.016 300.652C411.714 300.652 411.448 300.68 411.219 300.734C410.99 300.789 410.797 300.87 410.641 300.977C410.484 301.083 410.367 301.214 410.289 301.367C410.208 301.521 410.168 301.697 410.168 301.895C410.168 302.092 410.208 302.268 410.289 302.422C410.367 302.573 410.484 302.702 410.641 302.809C410.797 302.913 410.99 302.992 411.219 303.047C411.448 303.102 411.714 303.129 412.016 303.129L412.293 303.129C412.592 303.129 412.858 303.102 413.09 303.047C413.319 302.992 413.513 302.911 413.672 302.805C413.828 302.698 413.947 302.568 414.027 302.414C414.108 302.26 414.148 302.085 414.148 301.887C414.148 301.689 414.108 301.513 414.027 301.359C413.947 301.206 413.828 301.077 413.672 300.973C413.513 300.868 413.319 300.789 413.09 300.734C412.858 300.68 412.592 300.652 412.293 300.652ZM413.113 295.328L413.113 294.16C413.496 294.184 413.836 294.289 414.133 294.477C414.43 294.661 414.661 294.921 414.828 295.254C414.995 295.585 415.078 295.983 415.078 296.449C415.078 296.814 415.016 297.141 414.891 297.43C414.763 297.719 414.581 297.966 414.344 298.172C414.107 298.375 413.82 298.53 413.484 298.637C413.148 298.743 412.772 298.797 412.355 298.797L411.961 298.797C411.544 298.797 411.168 298.742 410.832 298.633C410.493 298.521 410.206 298.362 409.969 298.156C409.732 297.948 409.549 297.699 409.422 297.41C409.294 297.121 409.23 296.798 409.23 296.441C409.23 295.967 409.316 295.568 409.488 295.242C409.66 294.914 409.897 294.66 410.199 294.48C410.501 294.298 410.845 294.189 411.23 294.152L411.23 295.324C411.001 295.337 410.807 295.383 410.648 295.461C410.487 295.539 410.366 295.658 410.285 295.816C410.202 295.973 410.16 296.181 410.16 296.441C410.16 296.637 410.197 296.807 410.27 296.953C410.342 297.099 410.453 297.221 410.602 297.32C410.75 297.419 410.937 297.493 411.164 297.543C411.388 297.59 411.651 297.613 411.953 297.613L412.355 297.613C412.65 297.613 412.909 297.591 413.133 297.547C413.354 297.503 413.542 297.435 413.695 297.344C413.846 297.25 413.961 297.13 414.039 296.984C414.115 296.836 414.152 296.658 414.152 296.449C414.152 296.204 414.113 296.003 414.035 295.844C413.957 295.685 413.841 295.564 413.687 295.48C413.534 295.395 413.342 295.344 413.113 295.328ZM409.312 290.25L409.312 289.082L413.07 289.082C413.508 289.082 413.876 289.176 414.176 289.363C414.475 289.548 414.701 289.805 414.852 290.133C415.003 290.458 415.078 290.833 415.078 291.258C415.078 291.682 415.003 292.06 414.852 292.391C414.701 292.719 414.475 292.977 414.176 293.164C413.876 293.349 413.508 293.441 413.07 293.441L409.312 293.441L409.312 292.27L413.07 292.27C413.326 292.27 413.534 292.229 413.695 292.148C413.857 292.068 413.975 291.952 414.051 291.801C414.126 291.647 414.164 291.466 414.164 291.258C414.164 291.044 414.126 290.863 414.051 290.715C413.975 290.564 413.857 290.449 413.695 290.371C413.534 290.29 413.326 290.25 413.07 290.25L409.312 290.25ZM413.512 285.156C413.41 285.156 413.319 285.172 413.238 285.203C413.155 285.232 413.079 285.286 413.012 285.367C412.941 285.448 412.872 285.561 412.805 285.707C412.737 285.853 412.667 286.042 412.594 286.273C412.51 286.531 412.417 286.776 412.312 287.008C412.208 287.237 412.087 287.44 411.949 287.617C411.809 287.792 411.646 287.93 411.461 288.031C411.276 288.13 411.061 288.18 410.816 288.18C410.579 288.18 410.365 288.128 410.172 288.023C409.977 287.919 409.81 287.773 409.672 287.586C409.531 287.398 409.423 287.177 409.348 286.922C409.272 286.664 409.234 286.382 409.234 286.074C409.234 285.655 409.31 285.289 409.461 284.977C409.612 284.664 409.819 284.422 410.082 284.25C410.345 284.076 410.646 283.988 410.984 283.988L410.984 285.152C410.818 285.152 410.672 285.187 410.547 285.258C410.419 285.326 410.319 285.43 410.246 285.57C410.173 285.708 410.137 285.883 410.137 286.094C410.137 286.297 410.168 286.466 410.23 286.602C410.29 286.737 410.372 286.839 410.477 286.906C410.578 286.974 410.693 287.008 410.82 287.008C410.917 287.008 411.004 286.984 411.082 286.937C411.16 286.888 411.233 286.815 411.301 286.719C411.368 286.622 411.432 286.504 411.492 286.363C411.552 286.223 411.611 286.06 411.668 285.875C411.762 285.565 411.867 285.293 411.984 285.059C412.102 284.822 412.233 284.624 412.379 284.465C412.525 284.306 412.69 284.186 412.875 284.105C413.06 284.025 413.27 283.984 413.504 283.984C413.751 283.984 413.973 284.033 414.168 284.129C414.363 284.225 414.529 284.365 414.664 284.547C414.799 284.729 414.902 284.947 414.973 285.199C415.043 285.452 415.078 285.734 415.078 286.047C415.078 286.328 415.042 286.605 414.969 286.879C414.893 287.152 414.78 287.401 414.629 287.625C414.478 287.846 414.285 288.023 414.051 288.156C413.816 288.289 413.539 288.355 413.219 288.355L413.219 287.18C413.396 287.18 413.546 287.152 413.668 287.098C413.79 287.043 413.889 286.966 413.965 286.867C414.04 286.766 414.095 286.646 414.129 286.508C414.163 286.367 414.18 286.214 414.18 286.047C414.18 285.844 414.151 285.677 414.094 285.547C414.036 285.414 413.957 285.316 413.855 285.254C413.754 285.189 413.639 285.156 413.512 285.156ZM415 279.449L415 280.687L414.086 280.68L414.086 279.449C414.086 279.142 414.017 278.883 413.879 278.672C413.738 278.461 413.534 278.302 413.266 278.195C412.997 278.086 412.673 278.031 412.293 278.031L412.016 278.031C411.724 278.031 411.467 278.062 411.246 278.125C411.025 278.185 410.839 278.275 410.687 278.395C410.536 278.514 410.423 278.661 410.348 278.836C410.27 279.01 410.23 279.211 410.23 279.437L410.23 280.711L409.312 280.711L409.312 279.437C409.312 279.057 409.378 278.71 409.508 278.395C409.635 278.077 409.819 277.802 410.059 277.57C410.298 277.339 410.585 277.16 410.918 277.035C411.249 276.908 411.617 276.844 412.023 276.844L412.293 276.844C412.697 276.844 413.065 276.908 413.398 277.035C413.732 277.16 414.018 277.339 414.258 277.57C414.495 277.799 414.678 278.074 414.809 278.395C414.936 278.712 415 279.064 415 279.449ZM409.312 280.023L415 280.023L415 281.195L409.312 281.195L409.312 280.023ZM409.312 274.746L415 274.746L415 275.914L409.312 275.914L409.312 274.746ZM412.973 271.434L412.973 272.883L412.059 272.883L412.059 271.434C412.059 271.21 412.022 271.027 411.949 270.887C411.874 270.746 411.77 270.643 411.637 270.578C411.504 270.513 411.354 270.48 411.187 270.48C411.018 270.48 410.861 270.513 410.715 270.578C410.569 270.643 410.452 270.746 410.363 270.887C410.275 271.027 410.23 271.21 410.23 271.434L410.23 272.477L415 272.477L415 273.648L409.312 273.648L409.312 271.434C409.312 270.988 409.393 270.607 409.555 270.289C409.714 269.969 409.934 269.724 410.215 269.555C410.496 269.385 410.818 269.301 411.18 269.301C411.547 269.301 411.865 269.385 412.133 269.555C412.401 269.724 412.608 269.969 412.754 270.289C412.9 270.607 412.973 270.988 412.973 271.434Z",
    fill: "#123C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 98.4395V107H20.2676V100.115L18.1758 100.824V99.6582L21.5098 98.4395H21.6797ZM30.2051 102.02V103.414C30.2051 104.082 30.1387 104.652 30.0059 105.125C29.877 105.594 29.6895 105.975 29.4434 106.268C29.1973 106.561 28.9023 106.775 28.5586 106.912C28.2188 107.049 27.8379 107.117 27.416 107.117C27.0801 107.117 26.7676 107.074 26.4785 106.988C26.1934 106.902 25.9355 106.768 25.7051 106.584C25.4746 106.4 25.2773 106.164 25.1133 105.875C24.9531 105.582 24.8281 105.232 24.7383 104.826C24.6523 104.42 24.6094 103.949 24.6094 103.414V102.02C24.6094 101.348 24.6758 100.781 24.8086 100.32C24.9414 99.8555 25.1309 99.4785 25.377 99.1895C25.623 98.8965 25.916 98.6836 26.2559 98.5508C26.5996 98.418 26.9824 98.3516 27.4043 98.3516C27.7441 98.3516 28.0566 98.3945 28.3418 98.4805C28.6309 98.5625 28.8887 98.6934 29.1152 98.873C29.3457 99.0527 29.541 99.2871 29.7012 99.5762C29.8652 99.8613 29.9902 100.207 30.0762 100.613C30.1621 101.016 30.2051 101.484 30.2051 102.02ZM28.793 103.613V101.809C28.793 101.469 28.7734 101.17 28.7344 100.912C28.6953 100.65 28.6367 100.43 28.5586 100.25C28.4844 100.066 28.3906 99.918 28.2773 99.8047C28.1641 99.6875 28.0352 99.6035 27.8906 99.5527C27.7461 99.498 27.584 99.4707 27.4043 99.4707C27.1855 99.4707 26.9902 99.5137 26.8184 99.5996C26.6465 99.6816 26.502 99.8145 26.3848 99.998C26.2676 100.182 26.1777 100.424 26.1152 100.725C26.0566 101.021 26.0273 101.383 26.0273 101.809V103.613C26.0273 103.957 26.0469 104.26 26.0859 104.521C26.125 104.783 26.1836 105.008 26.2617 105.195C26.3398 105.379 26.4336 105.531 26.543 105.652C26.6562 105.77 26.7852 105.855 26.9297 105.91C27.0781 105.965 27.2402 105.992 27.416 105.992C27.6387 105.992 27.8359 105.949 28.0078 105.863C28.1797 105.777 28.3242 105.641 28.4414 105.453C28.5586 105.262 28.6465 105.014 28.7051 104.709C28.7637 104.404 28.793 104.039 28.793 103.613Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 146.439V155H20.2676V148.115L18.1758 148.824V147.658L21.5098 146.439H21.6797ZM28.5 146.439V155H27.0879V148.115L24.9961 148.824V147.658L28.3301 146.439H28.5Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 194.439V203H20.2676V196.115L18.1758 196.824V195.658L21.5098 194.439H21.6797ZM30.3633 201.875V203H24.6445V202.033L27.4219 199.004C27.7266 198.66 27.9668 198.363 28.1426 198.113C28.3184 197.863 28.4414 197.639 28.5117 197.439C28.5859 197.236 28.623 197.039 28.623 196.848C28.623 196.578 28.5723 196.342 28.4707 196.139C28.373 195.932 28.2285 195.77 28.0371 195.652C27.8457 195.531 27.6133 195.471 27.3398 195.471C27.0234 195.471 26.7578 195.539 26.543 195.676C26.3281 195.812 26.166 196.002 26.0566 196.244C25.9473 196.482 25.8926 196.756 25.8926 197.064H24.4805C24.4805 196.568 24.5938 196.115 24.8203 195.705C25.0469 195.291 25.375 194.963 25.8047 194.721C26.2344 194.475 26.752 194.352 27.3574 194.352C27.9277 194.352 28.4121 194.447 28.8105 194.639C29.209 194.83 29.5117 195.102 29.7188 195.453C29.9297 195.805 30.0352 196.221 30.0352 196.701C30.0352 196.967 29.9922 197.23 29.9062 197.492C29.8203 197.754 29.6973 198.016 29.5371 198.277C29.3809 198.535 29.1953 198.795 28.9805 199.057C28.7656 199.314 28.5293 199.576 28.2715 199.842L26.4258 201.875H30.3633Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 242.439V251H20.2676V244.115L18.1758 244.824V243.658L21.5098 242.439H21.6797ZM26.3027 246.096H27.1465C27.4746 246.096 27.7461 246.039 27.9609 245.926C28.1797 245.812 28.3418 245.656 28.4473 245.457C28.5527 245.258 28.6055 245.029 28.6055 244.771C28.6055 244.502 28.5566 244.271 28.459 244.08C28.3652 243.885 28.2207 243.734 28.0254 243.629C27.834 243.523 27.5898 243.471 27.293 243.471C27.043 243.471 26.8164 243.521 26.6133 243.623C26.4141 243.721 26.2559 243.861 26.1387 244.045C26.0215 244.225 25.9629 244.439 25.9629 244.689H24.5449C24.5449 244.236 24.6641 243.834 24.9023 243.482C25.1406 243.131 25.4648 242.855 25.875 242.656C26.2891 242.453 26.7539 242.352 27.2695 242.352C27.8203 242.352 28.3008 242.443 28.7109 242.627C29.125 242.807 29.4473 243.076 29.6777 243.436C29.9082 243.795 30.0234 244.24 30.0234 244.771C30.0234 245.014 29.9668 245.26 29.8535 245.51C29.7402 245.76 29.5723 245.988 29.3496 246.195C29.127 246.398 28.8496 246.564 28.5176 246.693C28.1855 246.818 27.8008 246.881 27.3633 246.881H26.3027V246.096ZM26.3027 247.197V246.424H27.3633C27.8633 246.424 28.2891 246.482 28.6406 246.6C28.9961 246.717 29.2852 246.879 29.5078 247.086C29.7305 247.289 29.8926 247.521 29.9941 247.783C30.0996 248.045 30.1523 248.322 30.1523 248.615C30.1523 249.014 30.0801 249.369 29.9355 249.682C29.7949 249.99 29.5938 250.252 29.332 250.467C29.0703 250.682 28.7637 250.844 28.4121 250.953C28.0645 251.062 27.6855 251.117 27.2754 251.117C26.9082 251.117 26.5566 251.066 26.2207 250.965C25.8848 250.863 25.584 250.713 25.3184 250.514C25.0527 250.311 24.8418 250.059 24.6855 249.758C24.5332 249.453 24.457 249.102 24.457 248.703H25.8691C25.8691 248.957 25.9277 249.182 26.0449 249.377C26.166 249.568 26.334 249.719 26.5488 249.828C26.7676 249.938 27.0176 249.992 27.2988 249.992C27.5957 249.992 27.8516 249.939 28.0664 249.834C28.2812 249.729 28.4453 249.572 28.5586 249.365C28.6758 249.158 28.7344 248.908 28.7344 248.615C28.7344 248.283 28.6699 248.014 28.541 247.807C28.4121 247.6 28.2285 247.447 27.9902 247.35C27.752 247.248 27.4707 247.197 27.1465 247.197H26.3027Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 290.439V299H20.2676V292.115L18.1758 292.824V291.658L21.5098 290.439H21.6797ZM30.5215 295.959V297.084H24.3691L24.3223 296.234L28.002 290.469H29.1328L27.9082 292.566L25.793 295.959H30.5215ZM29.4551 290.469V299H28.043V290.469H29.4551Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 338.439V347H20.2676V340.115L18.1758 340.824V339.658L21.5098 338.439H21.6797ZM26.127 343.033L25.002 342.758L25.4648 338.469H30.0645V339.664H26.6367L26.4023 341.756C26.5352 341.678 26.7188 341.602 26.9531 341.527C27.1875 341.449 27.4551 341.41 27.7559 341.41C28.1582 341.41 28.5176 341.477 28.834 341.609C29.1543 341.738 29.4258 341.928 29.6484 342.178C29.8711 342.424 30.041 342.725 30.1582 343.08C30.2754 343.432 30.334 343.828 30.334 344.27C30.334 344.664 30.2754 345.033 30.1582 345.377C30.0449 345.721 29.873 346.023 29.6426 346.285C29.4121 346.547 29.1211 346.752 28.7695 346.9C28.4219 347.045 28.0098 347.117 27.5332 347.117C27.1777 347.117 26.8359 347.066 26.5078 346.965C26.1836 346.859 25.8926 346.705 25.6348 346.502C25.377 346.295 25.1699 346.041 25.0137 345.74C24.8574 345.436 24.7676 345.086 24.7441 344.691H26.127C26.1621 344.969 26.2383 345.205 26.3555 345.4C26.4766 345.592 26.6367 345.738 26.8359 345.84C27.0352 345.941 27.2656 345.992 27.5273 345.992C27.7656 345.992 27.9707 345.951 28.1426 345.869C28.3145 345.783 28.457 345.662 28.5703 345.506C28.6875 345.346 28.7734 345.158 28.8281 344.943C28.8867 344.729 28.916 344.49 28.916 344.229C28.916 343.979 28.8828 343.75 28.8164 343.543C28.7539 343.336 28.6582 343.156 28.5293 343.004C28.4043 342.852 28.2461 342.734 28.0547 342.652C27.8633 342.566 27.6426 342.523 27.3926 342.523C27.0566 342.523 26.7988 342.572 26.6191 342.67C26.4434 342.768 26.2793 342.889 26.127 343.033Z",
    fill: "#71757A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 102,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 106C59 103.791 60.7909 102 63 102V150C60.7909 150 59 148.209 59 146V106Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 67,
    y: 110,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 67,
    y: 118,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 358,
    width: 68,
    height: 33,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 362C59 359.791 60.7909 358 63 358V391C60.7909 391 59 389.209 59 387V362Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 67,
    y: 366,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 67,
    y: 374,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 358,
    width: 68,
    height: 33,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 362C329 359.791 330.791 358 333 358V391C330.791 391 329 389.209 329 387V362Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 337,
    y: 366,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 337,
    y: 374,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 198,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 202C59 199.791 60.7909 198 63 198V246C60.7909 246 59 244.209 59 242V202Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 67,
    y: 206,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 67,
    y: 214,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 294,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 298C59 295.791 60.7909 294 63 294V342C60.7909 342 59 340.209 59 338V298Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 67,
    y: 302,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 67,
    y: 310,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 102,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 106C149 103.791 150.791 102 153 102V150C150.791 150 149 148.209 149 146V106Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 157,
    y: 110,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 157,
    y: 118,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 198,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 202C149 199.791 150.791 198 153 198V246C150.791 246 149 244.209 149 242V202Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 157,
    y: 206,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 157,
    y: 214,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 247,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 251C149 248.791 150.791 247 153 247V295C150.791 295 149 293.209 149 291V251Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 157,
    y: 255,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 157,
    y: 263,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 102,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 106C239 103.791 240.791 102 243 102V150C240.791 150 239 148.209 239 146V106Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 247,
    y: 110,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 247,
    y: 118,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 198,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 202C239 199.791 240.791 198 243 198V246C240.791 246 239 244.209 239 242V202Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 247,
    y: 206,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 247,
    y: 214,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239,
    y: 294,
    width: 68,
    height: 97,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 298C239 295.791 240.791 294 243 294V391C240.791 391 239 389.209 239 387V298Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 247,
    y: 302,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 247,
    y: 310,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 102,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 106C329 103.791 330.791 102 333 102V150C330.791 150 329 148.209 329 146V106Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 337,
    y: 110,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 337,
    y: 118,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 198,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 202C329 199.791 330.791 198 333 198V246C330.791 246 329 244.209 329 242V202Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 337,
    y: 206,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 337,
    y: 214,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419,
    y: 102,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 106C419 103.791 420.791 102 423 102V150C420.791 150 419 148.209 419 146V106Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 427,
    y: 110,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 427,
    y: 118,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419,
    y: 198,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 202C419 199.791 420.791 198 423 198V246C420.791 246 419 244.209 419 242V202Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 427,
    y: 206,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 427,
    y: 214,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419,
    y: 296,
    width: 68,
    height: 47,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 300C419 297.791 420.791 296 423 296V343C420.791 343 419 341.209 419 339V300Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 427,
    y: 304,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 427,
    y: 312,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419,
    y: 247,
    width: 68,
    height: 48,
    rx: 4,
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 251C419 248.791 420.791 247 423 247V295C420.791 295 419 293.209 419 291V251Z",
    fill: "#4798E1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 427,
    y: 255,
    width: 52,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 427,
    y: 263,
    width: 25,
    height: 4,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7791 18.2225H19.2227V37.7789H38.7791V18.2225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4941 25.2626L31.3902 26.5426L32.7982 25.5186V32.9429H34.3343V23.2145H33.0543L30.4941 25.2626Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0612 27.7739C28.6168 27.2637 28.9617 26.5561 28.9617 25.7747C28.9617 24.2218 27.599 22.9586 25.9242 22.9586C24.5002 22.9586 23.2823 23.8555 22.9641 25.1392L24.4371 25.5134C24.5837 24.9231 25.2086 24.4947 25.9242 24.4947C26.7616 24.4947 27.4434 25.0689 27.4434 25.7747C27.4434 26.4805 26.7616 27.0548 25.9242 27.0548H25.038V28.5909H25.9242C26.8852 28.5909 27.6959 29.2584 27.6959 30.0487C27.6959 30.8523 26.9261 31.5065 25.9793 31.5065C25.1242 31.5065 24.3935 30.9643 24.2779 30.246L22.7783 30.4914C23.0112 31.9457 24.3873 33.0426 25.9785 33.0426C27.7625 33.0426 29.2142 31.6994 29.2142 30.0487C29.2142 29.1393 28.7661 28.3233 28.0612 27.7739Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8901 44.0016H20.1116L19.2227 40.4458L20.1116 36.8901H37.8901L38.7791 40.4458L37.8901 44.0016Z",
    fill: "#FBC02D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4444 37.7789L45.0001 36.89V19.1115L41.4444 18.2225L37.8887 19.1115V36.89L41.4444 37.7789Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.89 19.1114L38.7789 15.5557L37.89 12H15.6668C14.1938 12 13 13.1938 13 14.6668V36.89L16.5557 37.7789L20.1114 36.89V19.1114H37.89Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8887 36.8901V44.0016L45.0001 36.8901H37.8887Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3333 12H37.8887V19.1114H45.0001V14.6668C45.0001 13.1938 43.8063 12 42.3333 12Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6668 44.0016H20.1114V36.8901H13V41.3348C13 42.8077 14.1938 44.0016 15.6668 44.0016Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 102.5,
    x2: 39,
    y2: 102.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 150.5,
    x2: 39,
    y2: 150.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 198.5,
    x2: 39,
    y2: 198.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 246.5,
    x2: 39,
    y2: 246.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 294.5,
    x2: 39,
    y2: 294.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 342.5,
    x2: 39,
    y2: 342.5,
    stroke: "#DADCE0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 54.5,
    x2: 1,
    y2: 54.5,
    stroke: "url(#paint0_linear_1780_28321)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 497,
    height: 391,
    rx: 16.5,
    stroke: "#DADCE0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1780_28321",
    x: 47,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_28321",
    result: "effect2_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1780_28321",
    x: 137,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1780_28321",
    x: 227,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1780_28321",
    x: 317,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1780_28321",
    x: 407,
    y: 55,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_1780_28321",
    x: 47,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_28321",
    result: "effect2_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1780_28321",
    x: 137,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1780_28321",
    x: 227,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1780_28321",
    x: 317,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_1780_28321",
    x: 407,
    y: 103,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_1780_28321",
    x: 47,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_28321",
    result: "effect2_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_1780_28321",
    x: 137,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_1780_28321",
    x: 227,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_1780_28321",
    x: 317,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_1780_28321",
    x: 407,
    y: 151,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_ii_1780_28321",
    x: 47,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_28321",
    result: "effect2_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_1780_28321",
    x: 137,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_1780_28321",
    x: 227,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_1780_28321",
    x: 317,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_1780_28321",
    x: 407,
    y: 199,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_ii_1780_28321",
    x: 47,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_28321",
    result: "effect2_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_1780_28321",
    x: 137,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_1780_28321",
    x: 227,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_1780_28321",
    x: 317,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_1780_28321",
    x: 407,
    y: 247,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_ii_1780_28321",
    x: 47,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_28321",
    result: "effect2_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_i_1780_28321",
    x: 137,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_i_1780_28321",
    x: 227,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_i_1780_28321",
    x: 317,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_i_1780_28321",
    x: 407,
    y: 295,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_ii_1780_28321",
    x: 47,
    y: 343,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1780_28321",
    result: "effect2_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_i_1780_28321",
    x: 137,
    y: 343,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_i_1780_28321",
    x: 227,
    y: 343,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_i_1780_28321",
    x: 317,
    y: 343,
    width: 90,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_i_1780_28321",
    x: 47,
    y: 1,
    width: 450,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.862745 0 0 0 0 0.878431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1780_28321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1780_28321",
    x1: 47,
    y1: 55,
    x2: 0.999999,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCE0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1780_28321"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 496,
    height: 390,
    rx: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/frame1.83bcb591031c32ea7978563eb3432007.svg";
export { ForwardRef as ReactComponent };